// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:04:36.836Z
// Property: The Residences at St. Joseph's Court (ID: 6767906449166355)
// Collections: 34 amenities, 2 floorplans (live), 16 photos, 76 POIs, 2 virtual tours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166355",
  "property_external_id": "30916",
  "property_zillow_url": "https://www.zillow.com/apartments/levittown-pa/the-residences-at-st.-joseph-court/Bd6VF8/",
  "property_apartments_url": "https://www.apartments.com/the-residences-at-st-joseph-court-levittown-pa/m5q3e8k/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Residences+at+St.+Joseph's+Court+Apartment+Homes/data=!4m2!3m1!1s0x0:0xa6d279b8bf045df9?sa=X&ved=2ahUKEwjC4sDvgrmSAxW6qpUCHWQeOPkQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-residences-at-st.-joseph's-court",
  "property_name": "The Residences at St. Joseph's Court",
  "property_website_url": "https://www.theresidencesatstjosephcourt.com/",
  "property_domain": "https://www.theresidencesatstjosephcourt.com/",
  "property_address": "200 Chapel Court",
  "property_full_address": "200 Chapel Ct, Levittown, PA 19054",
  "property_address_1": "200 Chapel Ct",
  "property_address_2": null,
  "property_address_city": "Levittown",
  "property_address_state": "PA",
  "property_address_zip_full": "19054-2000",
  "property_address_zip": "19054",
  "property_address_country": "US",
  "property_address_county": "Bucks County",
  "property_neighborhood_address": "Thornridge",
  "property_address_latitude": "40.1806271",
  "property_address_longitude": "-74.82280899999999",
  "property_email": "thenolan.pm@aionmanagement.com",
  "property_phone": "(445) 888-1825",
  "property_call_tracking_phone": "844-905-2794",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At The Residences at St. Joseph's Court 55+ in Levittown, PA, you’ll enjoy thoughtfully designed one and two-bedroom floor plans paired with upscale amenities. From a state-of-the-art fitness center to inviting social spaces, your ideal lifestyle awaits—nestle into spacious comfort and modern elegance. Uncover your perfect haven today!",
  "property_long_description": "Welcome to The Residences at St. Joseph's Court 55+, where comfort meets convenience in the heart of Levittown, PA. Our thoughtfully designed community offers a variety of floor plans, including spacious one and two-bedroom apartments that ensure you find the perfect fit for your lifestyle. Each apartment boasts modern amenities such as hardwood floors, stainless steel appliances, granite countertops, and double vanities—elevating your everyday living experience.\n\nAt The Residences, indulge in unrivaled amenities that make each day feel special. Stay active in our fully-equipped fitness center, unwind in the inviting clubhouse, or participate in our planned social activities that foster a vibrant community atmosphere. With key fob entry and a dedicated property manager on-site, you’ll enjoy peace of mind and effortless living.\n\nOur residents appreciate the convenience of in-unit washers and dryers, high-speed internet access, and air conditioning, ensuring comfort and connectivity in every season. Spacious living areas, including large bedrooms, family rooms, and offices, provide ample room for both relaxation and productivity, while inviting balconies and patios extend your living space outdoors.\n\nEmphasizing accessibility and inclusivity, our wheelchair-accessible units cater to your specific needs. Plus, with added features like ceiling fans, a sprinkler system, and controlled access, we prioritize your comfort and safety.\n\nDiscover your next home at The Residences at St. Joseph's Court 55+ today! Browse our availability or schedule a tour to experience firsthand the warmth and community spirit our apartments have to offer. Don't miss out on this opportunity to elevate your living experience!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-3afb-77e6-a17f-903e10626960.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a multifamily apartment building with a parking lot.",
    "public_id": "019fce0f-3afb-77e6-a17f-903e10626960",
    "storage_key": "property/6767906449166355/019fce0f-3afb-77e6-a17f-903e10626960.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "48",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs, cats, and service animals are welcome (all must be housebroken; no breeding). A maximum of two pets per unit.",
  "property_pet_policy_description": "Dogs, cats, and service animals are welcome (all must be housebroken; no breeding). A maximum of two pets per unit. One-time non‑refundable pet fee: $300 for one pet, $350 for two. Monthly pet rent: $50 for one pet, $75 for two. No weight restrictions.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://residencesatstjoseph.loftliving.com/login",
  "property_apply_now_url": "https://www.theresidencesatstjosephcourt.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026c-94ef-70de-b90b-cc3130a37fe8.webp",
  "property_primary_logo_media": {
    "alt_text": "The Residences at St. Joseph Court logo",
    "public_id": "019d026c-94ef-70de-b90b-cc3130a37fe8",
    "storage_key": "property/6767906449166355/019d026c-94ef-70de-b90b-cc3130a37fe8.webp",
    "width": 250,
    "height": 110
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-ca8c-7204-ae42-53920e39e9a1.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d026e-ca8c-7204-ae42-53920e39e9a1",
    "storage_key": "property/6767906449166355/019d026e-ca8c-7204-ae42-53920e39e9a1.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026c-94ef-70de-b90b-cc3130a37fe8.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Residences at St. Joseph Court logo",
    "public_id": "019d026c-94ef-70de-b90b-cc3130a37fe8",
    "storage_key": "property/6767906449166355/019d026c-94ef-70de-b90b-cc3130a37fe8.webp",
    "width": 250,
    "height": 110
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026c-94ef-70de-b90b-cc3130a37fe8.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Residences at St. Joseph Court logo",
    "public_id": "019d026c-94ef-70de-b90b-cc3130a37fe8",
    "storage_key": "property/6767906449166355/019d026c-94ef-70de-b90b-cc3130a37fe8.webp",
    "width": 250,
    "height": 110
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "750 - 1150",
  "property_sqft_min": "750",
  "property_sqft_max": "1150",
  "property_price_range": "1956 - 2776",
  "property_price_min": "1956",
  "property_price_max": "2776",
  "property_available_units": null,
  "property_facebook_url": "https://facebook.com/TheResidencesatStJosephCourt",
  "property_instagram_url": "https://www.instagram.com/theresidencesatstjoseph",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJnfTsWxdRwYkR-V0Ev7h50qY",
  "property_youtube_url": "https://www.youtube.com/watch?v=ffd-OS-noig",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Senior+Apartments&find_loc=Levittown%2C+PA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Residences at St. Joseph's Court 55+",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection Here",
  "property_home_amenities_blurb": "Welcome to The Residences at St. Joseph's Court 55+ in Levittown, PA, where comfort meets convenience. Choose from our thoughtfully designed one and two-bedroom floor plans, featuring gourmet kitchens, elegant granite countertops, and spacious layouts. Enjoy our vibrant community with a fitness center, clubhouse, and planned social activities tailored for you.",
  "property_home_floorplans_blurb": "At The Residences at St. Joseph's Court 55+, located in the heart of Levittown, PA, a harmonious blend of comfort and style awaits. Whether you’re seeking a cozy one-bedroom retreat or a spacious two-bedroom haven, our thoughtfully designed floor plans cater to your every need. Browse our available apartment homes today!",
  "property_home_gallery_blurb": "Welcome to The Residences at St. Joseph's Court 55+, where contemporary living meets comfort. Choose from spacious one- and two-bedroom floor plans adorned with granite countertops and stainless steel appliances. Enjoy exclusive amenities like a fully-equipped fitness center, lounge, and planned social activities. Picture yourself living here in Levittown, PA!",
  "property_home_neighborhood_blurb": "At The Residences at St. Joseph's Court 55+, find your haven in Levittown, PA, with spacious one and two-bedroom floor plans. Immerse yourself in vibrant local life, with nearby parks, schools, and the Fairless Hills YMCA. Enjoy the perfect blend of comfort and convenience at your new community!",
  "property_home_reviews_blurb": "At The Residences at St. Joseph's Court 55+ in Levittown, PA, residents rave about the vibrant atmosphere, calling it \"a place that feels like home.\" Join a community that prioritizes comfort and connection. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Welcome to The Residences at St. Joseph's Court 55+, where vibrant community living meets convenience! Nestled in Levittown, PA, you'll find amenities like parks, schools, and shopping centers nearby. Engage in educational pursuits or enjoy peaceful nature walks—your ideal lifestyle is just outside your doorstep. Uncover the charm of your new neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Residences at St. Joseph's Court 55+, living in Levittown has never felt so inviting. Choose from spacious one- and two-bedroom floor plans adorned with granite countertops and stainless steel appliances. Enjoy our fitness center, clubhouse, and engaging social activities—all nestled in a smoke-free, secure environment. Your perfect home awaits!",
  "property_applynow_blurb": "Welcome to The Residences at St. Joseph's Court 55+, where modern comfort meets community spirit in Levittown, PA. Choose from spacious one or two-bedroom floor plans, complete with granite countertops, stainless steel appliances, and ample storage. Enjoy amenities like a fitness center, clubhouse, and planned activities—all designed for your lifestyle. Find your new home and lease online today!",
  "property_contactus_blurb": "At The Residences at St. Joseph's Court 55+ in Levittown, PA, choose from thoughtfully designed one and two-bedroom floor plans tailored for comfort and convenience. Ready to learn more? Our leasing team is here to assist you! Connect with us today to uncover your perfect home.",
  "property_faqs_blurb": "At The Residences at St. Joseph's Court 55+ in Levittown, PA, we offer thoughtfully designed one and two-bedroom floor plans, tailored for comfort and style. Have questions? Our FAQs page provides insightful answers about our vibrant community. Join us and find your perfect home today!",
  "property_floorplans_blurb": "At The Residences at St. Joseph's Court 55+ in Levittown, PA, your ideal living space awaits. Choose from our thoughtfully designed one and two-bedroom floor plans tailored for comfort and style. Browse our available apartment homes and let your next chapter begin in a community that truly welcomes you.",
  "property_gallery_blurb": "At The Residences at St. Joseph's Court 55+, every detail is crafted for your comfort. Enjoy spacious one- and two-bedroom apartments featuring granite countertops, stainless steel appliances, and hardwood floors. With amenities like a fitness center, clubhouse, and planned social activities, imagine the vibrant lifestyle waiting for you in Levittown, PA!",
  "property_interactivemap_blurb": "Embrace a vibrant lifestyle at The Residences at St. Joseph's Court 55+ in Levittown, PA. Our thoughtfully designed one and two-bedroom apartments boast modern amenities like granite countertops, hardwood floors, and a fully-equipped fitness center. Enjoy social events, a clubhouse, and an interactive community map to find your perfect home!",
  "property_pets_blurb": "At The Residences at St. Joseph's Court 55+, your furry companions are cherished. Nestled in Levittown, PA, our vibrant community invites you to enjoy life with your dogs and cats by your side. Experience hassle-free living with our flexible pet policy—because every day is better with a pet.",
  "property_referafriend_blurb": "At The Residences at St. Joseph's Court 55+ in Levittown, PA, finding your perfect home is easy with our inviting one and two-bedroom floor plans. Share the joy of vibrant living—refer a friend to our community today, because great friends make great neighbors! Enjoy a life full of connection and comfort.",
  "property_residentaccess_blurb": "Welcome to The Residences at St. Joseph's Court 55+, where comfortable living meets vibrant community life in Levittown, PA. Enjoy a variety of thoughtfully designed floor plans, including one-bedroom and two-bedroom options. Log in to your resident portal to easily pay rent, schedule maintenance, and enjoy seamless living.",
  "property_reviews_blurb": "At The Residences at St. Joseph's Court 55+ in Levittown, PA, residents rave about the welcoming atmosphere and vibrant community spirit, stating, \"It truly feels like home here!\" Read more accolades from our satisfied residents and see why this is the perfect place for your next chapter!",
  "property_created_at": "1757012474585",
  "property_scheduletour_blurb": "Nestled in the heart of Levittown, PA, The Residences at St. Joseph's Court 55+ offers thoughtfully designed one and two-bedroom floor plans tailored for comfort and convenience. Ready to experience the warmth of our vibrant community? Schedule a tour today and hear from our residents about their delightful living experience!",
  "property_thankyou_blurb": "Thank you for your interest in The Residences at St. Joseph's Court 55+ in Levittown, PA! Our thoughtfully designed one and two-bedroom floor plans offer comfort and community. A team member will reach out soon to assist you in finding your perfect home among our charming options.",
  "property_virtualtours_blurb": "At The Residences at St. Joseph's Court 55+, located in vibrant Levittown, PA, you'll find thoughtfully designed one- and two-bedroom apartments. Immerse yourself in our community's charm by taking a virtual tour today—where comfort meets convenience in a thriving neighborhood for those aged 55 and better!",
  "property_copyright": "2025 All Rights Reserved. The Residences at St. Joseph's Court 55+",
  "property_seo_title_home": "The Residences at St. Joseph’s Court | 55+ Apartments",
  "property_seo_description_home": "Discover 55+ active adult apartments at St. Joseph Court in Levittown, PA. Enjoy modern amenities, comfort, and a vibrant community designed for you.",
  "property_seo_title_floorplans": "Floor Plans | 1 and 2 Bedroom 55+ Apts in Levittown, PA",
  "property_seo_description_floorplans": "The Residences at St. Joseph Court offers 55+ 1 and 2-bedroom apartments in Levittown, PA, with modern features and a convenient location near Queen Anne Park.",
  "property_seo_title_amenities": "Amenities | Levittown, PA 55+ Apartments For Rent",
  "property_seo_description_amenities": "The Residences at St. Joseph Court is a 55+ active community featuring amenities such as a fitness center, theater, sports lounge, elevator access, and more!",
  "property_seo_title_gallery": "Gallery | 55+ Apartments for Rent in Levittown, PA",
  "property_seo_description_gallery": "Discover 55+ apartment living in Levittown at The Residences at St. Joseph Court through our gallery featuring 1- and 2-bedroom layouts and amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | The Residences at St. Joseph's Court 55+ Apartments",
  "property_seo_description_virtualtours": "Step inside The Residences at St. Joseph's Court 55+ in Levittown, PA. Experience our one and two-bedroom apartments through an immersive virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | The Residences at St. Joseph's Court 55+ Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Residences at St. Joseph's Court 55+ in Levittown, PA. Enjoy spacious layouts, modern amenities, and a vibrant community!",
  "property_seo_title_neighborhood": "Neighborhood | 55+ Apartments Near Lower Bucks Hospital",
  "property_seo_description_neighborhood": "Live close to Regal UA Oxford Valley and Silver Lake Nature Center at The Residences at St. Joseph's Court. Our 55+ apartments are designed for your convenience.",
  "property_seo_title_contact": "Contact Us | The Residences at St. Joseph's Court 55+",
  "property_seo_description_contact": "Find your perfect haven at The Residences at St. Joseph's Court 55+ in Levittown, PA. Have questions? Our leasing team is ready to help—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Levittown, PA",
  "property_seo_description_faqs": "Uncover the answers you seek about The Residences at St. Joseph's Court 55+ in Levittown, PA. Your ideal living experience awaits—visit our FAQs today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Levittown, PA",
  "property_seo_description_reviews": "Join the vibrant community at The Residences at St. Joseph's Court 55+ in Levittown, PA. Hear firsthand what residents love about their new home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Levittown, PA",
  "property_seo_description_applynow": "Discover luxury 55+ living at The Residences at St. Joseph's Court in Levittown, PA. Enjoy spacious layouts, modern amenities, and a vibrant community!",
  "property_seo_title_residentaccess": "Resident Access | The Residences at St. Joseph's Court 55+",
  "property_seo_description_residentaccess": "Seamlessly manage your life at The Residences at St. Joseph's Court 55+! Log in to access rent payments, maintenance requests, and exclusive resident services.",
  "property_seo_title_referafriend": "Refer A Friend | The Residences at St. Joseph's Court 55+",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Residences at St. Joseph's Court 55+ in Levittown, PA, and enhance your vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Residences at St. Joseph's Court 55+",
  "property_seo_description_scheduletour": "Discover vibrant living at The Residences at St. Joseph's Court 55+. Schedule a tour today and enjoy an active lifestyle in Levittown!",
  "property_seo_title_privacy": "Privacy Policy | The Residences at St. Joseph's Court 55+",
  "property_seo_description_privacy": "Your privacy matters at The Residences at St. Joseph's Court 55+. Read our policy to understand how we protect your information in Levittown, PA.",
  "property_seo_title_accessibility": "Website Accessibility | The Residences at St. Joseph's Court 55+",
  "property_seo_description_accessibility": "Embrace a vibrant lifestyle at The Residences at St. Joseph's Court 55+. We prioritize digital accessibility for all residents in Levittown, PA. Join us today!",
  "property_seo_title_sitemap": "Sitemap | The Residences at St. Joseph's Court 55+",
  "property_seo_description_sitemap": "Unearth the charm of The Residences at St. Joseph's Court 55+ in Levittown, PA. Navigate our sitemap and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | The Residences at St. Joseph's Court 55+",
  "property_seo_description_thankyou": "Thank you for reaching out to The Residences at St. Joseph's Court 55+! Stay tuned—our team will be in touch soon with all the information you need.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1792699321009",
  "amenities": [
    {
      "id": "custom_f8c0f27f-efb1-42f3-a8c7-d8407f2c06c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_153e23ff-1944-4c0c-b45a-9fb580149211",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Business Station",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27ff6cf8-0d42-4da4-95bb-69fc91e44cfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4ca8dc0-822d-4c0a-ac7e-d6ff92e8e2e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91c209c2-5339-4e72-91e7-fbd85bd5714c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Elevator Access",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29df0ff5-1d5b-4dcd-9f10-362580d27b18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center w/ Strength Training Equipment",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c235b0ba-10a2-4ca3-a3a8-07bc1f314a28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6e86e240-0255-42fe-988e-0dc7c6ddc97e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Media Room/Theater",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ec95947-ea4e-46a7-970c-eaccbbc39c4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4356d536-0de3-4581-90d5-8bff24397d0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_871ad6ef-434d-46d8-8543-79cd48ecbef9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_744df2ef-0443-44d8-af5a-df9ddef145d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Private Membership Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b5887a0-f817-455e-8171-4c4301b990f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Lounge on Each Floor",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4fcea761-c2b5-44b4-9010-53c9ab2c7c83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Sports Lounge & Cardio Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7fb6f07-7644-49ea-a1a4-99b1c19cd9b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76543a22-d586-4ec2-9060-3fc58ec19e98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Center Kitchen Islands",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc8e4a0c-ec2e-4bdf-993d-c395fa46b353",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f5e31e5-71fe-41e9-ad7f-d418790288d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Classic 9-Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_19ff344f-67e9-4543-9407-cca689e4bd51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Double Sink Vanity in Main Bathroom",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76ec290a-5512-4773-be47-daada8f4666c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet-Style Kitchens w/ Garbage Disposals",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2677e76d-62f8-4d61-a1d0-a74cac3729b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f242bbc-3f22-424e-ba3c-3ad2ae25a1ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3ee1199-a0ca-4ab6-9f8b-6b60063bf6a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e4fa3b83-c1aa-4e05-adf9-97cc38148c0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7bcb5ad0-3a66-4f80-bc5c-3f76b97a5344",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Pantry Cabinet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b9b0c29-145c-4c7e-bbb6-7b21d2491a24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Natural Gas Heat",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_45629b3f-df6f-41be-90fd-ee5a79b22a9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized 42-Inch Kitchen Cabinets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_819b9622-c4e9-4504-88c9-92e156de5b2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Recessed Kitchen Lighting",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c11e33c-20e7-4698-b9c4-0a02ce4bc5bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Seated Shower w/ Clear Door",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dcc6f7d3-a0d0-4a82-b7f8-0d50ba5293e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3560f2b-4c04-47d6-b92a-3c18e2766210",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c743b60b-cb39-43a2-b3ab-b59d0bf672b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Active 55+ Adult Community",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_936c93ee-a815-439d-887d-e9f29f7aef38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Lounge",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_741c078e-f4ec-4890-8d91-59856bc7c74f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Terrace",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_56f090c9-f2a7-4f2e-912b-8450c8539459",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-4e33-76de-b4a8-1467716cbc8f.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with island, stainless steel appliances, and quartz countertops.",
        "public_id": "019fce0f-4e33-76de-b4a8-1467716cbc8f",
        "storage_key": "property/6767906449166355/019fce0f-4e33-76de-b4a8-1467716cbc8f.webp",
        "width": 2000,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek white cabinetry, a spacious island, and high-end stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Bright white kitchen with an island, stainless steel refrigerator and microwave, and ample cabinets at The Residences at St. Joseph's Court in Levittown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/5767906449162442/6767906449166355/069368c93e43f6a14700e91d0b74eaba.webp"
    },
    {
      "id": "custom_6ffc26a4-c493-49e9-bd7c-8948e384d283",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-4e04-769a-9068-6284bb27f1d6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island.",
        "public_id": "019fce0f-4e04-769a-9068-6284bb27f1d6",
        "storage_key": "property/6767906449166355/019fce0f-4e04-769a-9068-6284bb27f1d6.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring white cabinetry, a stainless steel refrigerator, microwave, and stove, with a central island perfect for meal prep or casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%287%29.jpg"
    },
    {
      "id": "custom_bd905d35-4de6-4714-a83d-ef24f2d49133",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-4f3d-7229-aaa3-592838efee4a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "019fce0f-4f3d-7229-aaa3-592838efee4a",
        "storage_key": "property/6767906449166355/019fce0f-4f3d-7229-aaa3-592838efee4a.webp",
        "width": 2000,
        "height": 1256
      },
      "title": "Apartment",
      "description": "Open-concept apartment kitchen featuring white cabinetry, quartz countertops, and stainless steel appliances.",
      "link": "false",
      "alt_text": "Open-concept kitchen with white cabinets, island, and stainless steel appliances at The Residences at St. Joseph's Court in Levittown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/5767906449162442/6767906449166355/c10fa4f1700cb0f143ffb66fc2446cfb.webp"
    },
    {
      "id": "custom_0456b4a7-e21e-4e1f-8276-d7f4bd9e1c10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-4e2d-761b-a8c5-90953eacef21.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, and shelving.",
        "public_id": "019fce0f-4e2d-761b-a8c5-90953eacef21",
        "storage_key": "property/6767906449166355/019fce0f-4e2d-761b-a8c5-90953eacef21.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Apartment",
      "description": "Spacious laundry area with a washer and dryer set, plus ample shelving for storage.",
      "link": "false",
      "alt_text": "Laundry room with washer, dryer, and shelving.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%289%29.jpg"
    },
    {
      "id": "custom_77f6f65e-a331-4aa0-aecf-8711e6169167",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-58d9-7498-ac01-6154478102e8.webp",
      "image_media": {
        "alt_text": "Empty living room with a sliding glass door leading to a balcony.",
        "public_id": "019fce0f-58d9-7498-ac01-6154478102e8",
        "storage_key": "property/6767906449166355/019fce0f-58d9-7498-ac01-6154478102e8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright, modern living space in a contemporary apartment with neutral finishes and a balcony.",
      "link": "false",
      "alt_text": "Bright empty living room with white walls, wood-look flooring, and a sliding glass door to a balcony at The Residences at St. Joseph's Court in Levittown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/5767906449162442/6767906449166355/4afda5459bd0b304378fde8f244ede2a.webp"
    },
    {
      "id": "custom_c86cc7ba-28bb-45b5-83f2-622fdc698eee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-59d3-73f1-aafc-6688e8ba39f2.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass doors leading to an exterior view.",
        "public_id": "019fce0f-59d3-73f1-aafc-6688e8ba39f2",
        "storage_key": "property/6767906449166355/019fce0f-59d3-73f1-aafc-6688e8ba39f2.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a sliding glass door and wood-look flooring, offering a view of the property's exterior.",
      "link": "false",
      "alt_text": "Living room with sliding glass doors leading to an exterior view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%288%29.jpg"
    },
    {
      "id": "custom_176e8102-a7f7-44fd-b52d-913aaf8be18d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-5a75-778e-80f9-7db54481cc18.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood-look flooring and a large window with blinds.",
        "public_id": "019fce0f-5a75-778e-80f9-7db54481cc18",
        "storage_key": "property/6767906449166355/019fce0f-5a75-778e-80f9-7db54481cc18.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright, empty apartment bedroom with a large window, blinds, white walls, and light wood-look flooring.",
      "link": "false",
      "alt_text": "Empty bedroom with a large window, white walls, and light wood-look flooring at The Residences at St. Joseph's Court in Levittown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/5767906449162442/6767906449166355/78876b01a624dae3ad8d401eab96f894.webp"
    },
    {
      "id": "custom_afb0f906-4766-4519-b946-6f4f56108c71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-5a97-7611-be40-950e6054e6a6.webp",
      "image_media": {
        "alt_text": "Empty living room with wood floors and a window.",
        "public_id": "019fce0f-5a97-7611-be40-950e6054e6a6",
        "storage_key": "property/6767906449166355/019fce0f-5a97-7611-be40-950e6054e6a6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright, unfurnished apartment room with neutral walls, wood-look flooring, and natural light.",
      "link": "false",
      "alt_text": "Empty beige bedroom with a large window and wood-look flooring at The Residences at St. Joseph's Court in Levittown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/5767906449162442/6767906449166355/0ec6e5fbdb3d4d9d9832d0cc8e29a81e.webp"
    },
    {
      "id": "custom_a1ca6bf8-2828-4df2-9b63-4ad182c4132e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-62f9-728f-88a2-f56815a0384d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, vanity, and toilet.",
        "public_id": "019fce0f-62f9-728f-88a2-f56815a0384d",
        "storage_key": "property/6767906449166355/019fce0f-62f9-728f-88a2-f56815a0384d.webp",
        "width": 1920,
        "height": 1276
      },
      "title": "Apartment",
      "description": "Bright and clean apartment bathroom featuring a spacious walk-in shower, sleek vanity, and modern fixtures.",
      "link": "false",
      "alt_text": "Modern bathroom with a walk-in shower, vanity, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%2810%29.jpg"
    },
    {
      "id": "custom_d7f0cf6b-b548-4476-b843-7b02dae0c5dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-646c-71b1-9829-9ad9b3276c7e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and stationary bike.",
        "public_id": "019fce0f-646c-71b1-9829-9ad9b3276c7e",
        "storage_key": "property/6767906449166355/019fce0f-646c-71b1-9829-9ad9b3276c7e.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring modern cardio equipment like treadmills and ellipticals, perfect for your workout routine.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical, and stationary bike.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%285%29.jpg"
    },
    {
      "id": "custom_70cb468f-d90c-44b0-9910-2900e3c84dd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-6499-716e-bb9c-f1bafa034115.webp",
      "image_media": {
        "alt_text": "Card room with tables and chairs.",
        "public_id": "019fce0f-6499-716e-bb9c-f1bafa034115",
        "storage_key": "property/6767906449166355/019fce0f-6499-716e-bb9c-f1bafa034115.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Community",
      "description": "Gather your friends for a game night in our community card room.",
      "link": "false",
      "alt_text": "Card room with tables and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%284%29.jpg"
    },
    {
      "id": "custom_8fe2d88f-5636-40ae-a697-86184da181cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-659e-7658-abf6-8ed4457b0e1e.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a sofa, coffee table, large TV, and an exit sign above double doors.",
        "public_id": "019fce0f-659e-7658-abf6-8ed4457b0e1e",
        "storage_key": "property/6767906449166355/019fce0f-659e-7658-abf6-8ed4457b0e1e.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, perfect for socializing or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "Spacious community lounge with a sofa, coffee table, large TV, and an exit sign above double doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%282%29.jpg"
    },
    {
      "id": "custom_279ca038-b9f7-482f-8fe4-d419aab6aa0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-6dbd-7748-b76d-aa22ba33ab4f.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sofa, coffee table, armchair, and dining table with chairs.",
        "public_id": "019fce0f-6dbd-7748-b76d-aa22ba33ab4f",
        "storage_key": "property/6767906449166355/019fce0f-6dbd-7748-b76d-aa22ba33ab4f.webp",
        "width": 1920,
        "height": 1213
      },
      "title": "Community",
      "description": "Spacious resident lounge featuring a comfortable grey sofa, glass coffee table, and bright windows.",
      "link": "false",
      "alt_text": "Resident lounge with beige walls, grey sofa, and large windows at The Residences at St. Joseph's Court in Levittown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/5767906449162442/6767906449166355/9184c0b1009ea96ec2c5e41ce41cf6aa.jpg"
    },
    {
      "id": "custom_a36711df-e21e-45bc-ac88-d837648aa1c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-6ef3-73fe-8b2f-a5e66e11a5a6.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel refrigerator, white cabinets, and a large sink area.",
        "public_id": "019fce0f-6ef3-73fe-8b2f-a5e66e11a5a6",
        "storage_key": "property/6767906449166355/019fce0f-6ef3-73fe-8b2f-a5e66e11a5a6.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Community",
      "description": "Bright and spacious kitchen featuring modern stainless steel appliances, ample white cabinetry, and a large sink area perfect for meal preparation.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel refrigerator, white cabinets, and a large sink area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%283%29.jpg"
    },
    {
      "id": "custom_fa4df637-92b0-439e-9568-a5c842dd37c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-6f63-766b-a86f-bb6a0ae52d7f.webp",
      "image_media": {
        "alt_text": "Covered patio with wicker furniture and ceiling fans overlooking a lawn.",
        "public_id": "019fce0f-6f63-766b-a86f-bb6a0ae52d7f",
        "storage_key": "property/6767906449166355/019fce0f-6f63-766b-a86f-bb6a0ae52d7f.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Community",
      "description": "Enjoy outdoor living on your private covered patio, complete with comfortable wicker seating and ceiling fans for a pleasant breeze.",
      "link": "false",
      "alt_text": "Covered patio with wicker furniture and ceiling fans overlooking a lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/The-Residences-POI+%281%29.jpg"
    },
    {
      "id": "custom_a1c2d2a3-aa4e-40e9-9b0c-7c3a490f4056",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-704c-74fb-9359-2d9f58cdc262.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with a parking lot and cars.",
        "public_id": "019fce0f-704c-74fb-9359-2d9f58cdc262",
        "storage_key": "property/6767906449166355/019fce0f-704c-74fb-9359-2d9f58cdc262.webp",
        "width": 1900,
        "height": 1265
      },
      "title": "Community",
      "description": "Beautifully maintained exterior of the apartment building, featuring a spacious parking lot with ample spaces for residents.",
      "link": "false",
      "alt_text": "Exterior view of a multi-building apartment complex with a parking lot in front at The Residences at St. Joseph's Court in Levittown, PA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f0996820/dms3rep/multi/5767906449162442/6767906449166355/e2257e2fbb7f7cac452d33cc720755ba.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_28b12ea0-4780-4ae1-b96c-e49e2821b83a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "The Bridge Coffee & Community",
      "poi_type": "Restaurants",
      "poi_address": "6800 Bristol Emilie Rd, Levittown, PA 19057, USA",
      "poi_short_description": "Laid-back coffee shop featuring vegetarian and vegan options, plus a share of its profits goes to the community.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-91a6-75a9-8324-7acf4409bd27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-91a6-75a9-8324-7acf4409bd27",
        "storage_key": "property/6767906449166355/019fd811-91a6-75a9-8324-7acf4409bd27.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://thebridge.coffee/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9395951217880589967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bridge-coffee--community",
      "poi_latitude": "40.1511347",
      "poi_longitude": "-74.856096",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 267-822-1963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e56e-72ed-a9a6-b7ab59671503.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e56e-72ed-a9a6-b7ab59671503",
        "storage_key": "property/6767906449166355/019fce10-e56e-72ed-a9a6-b7ab59671503.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-QdVA2JRwYkRj-arzNkfZYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d3a29aec-7990-4259-b9bd-17c483ea05ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Cafe Ferraro",
      "poi_type": "Restaurants",
      "poi_address": "523 S Oxford Valley Rd, Fairless Hills, PA 19030, USA",
      "poi_short_description": "Long-time cafe serving breakfast dishes, burgers, soups and other casual fare.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-932d-7591-ab5a-cbcc97cc23aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-932d-7591-ab5a-cbcc97cc23aa",
        "storage_key": "property/6767906449166355/019fd811-932d-7591-ab5a-cbcc97cc23aa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2280384384319160849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-ferraro",
      "poi_latitude": "40.1697233",
      "poi_longitude": "-74.8486625",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-945-7887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJybgEYw1RwYkREQKx-oONpR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd0802c0-3cac-465f-aba4-45a45a2d0de8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Violetwood Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1552 Haines Rd, Levittown, PA 19055, USA",
      "poi_short_description": "Easygoing eatery in the Kenwood Shopping Center serving breakfast and lunch favorites.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-7f3c-72ad-893d-0f527744301d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0f-7f3c-72ad-893d-0f527744301d",
        "storage_key": "property/6767906449166355/019fce0f-7f3c-72ad-893d-0f527744301d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17120125022382129941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "violetwood-cafe",
      "poi_latitude": "40.1359611",
      "poi_longitude": "-74.83198890000001",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-945-3383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSxS5b9RwYkRFQNdZQDnlu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a738cc57-6963-40cf-b7e5-aa7a053e0f1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Golden Dawn",
      "poi_type": "Restaurants",
      "poi_address": "7115 New Falls Rd, Levittown, PA 19055, USA",
      "poi_short_description": "Mellow-old school diner providing a long menu of traditional American & Italian eats till late.",
      "poi_long_description": "Mellow-old school diner providing a long menu of traditional American & Italian eats till late.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-9183-771d-8c46-2b8359b898b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-9183-771d-8c46-2b8359b898b4",
        "storage_key": "property/6767906449166355/019fd811-9183-771d-8c46-2b8359b898b4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goldendawnlevittown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16231992445387775732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-dawn",
      "poi_latitude": "40.1549861",
      "poi_longitude": "-74.8552361",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-945-4554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt4B7s55RwYkR9J4p2CCfQ-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b974f3af-a405-4257-8864-9473aa33a037",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Kasdon's Restaurant & Tavern",
      "poi_type": "Restaurants",
      "poi_address": "8736 New Falls Rd, Levittown, PA 19054, USA",
      "poi_short_description": "Relaxed American restaurant offering comfort food and a kids' menu, plus sports on TV.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-981e-70ee-854a-074aca204064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-981e-70ee-854a-074aca204064",
        "storage_key": "property/6767906449166355/019fd811-981e-70ee-854a-074aca204064.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://kasdonsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18044387780903850334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kasdons-restaurant--tavern",
      "poi_latitude": "40.1738889",
      "poi_longitude": "-74.8308333",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-547-0610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7q8IB9RwYkRXlEsXhWLavo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fa720707-9144-46f3-a068-c39fca3926a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Amore Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8630 New Falls Rd, Levittown, PA 19054, USA",
      "poi_short_description": "Casual Italian eatery that serves authentic cuisine using traditional methods, and features a BYOB policy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-96d3-7500-a9d9-0c06a4803ac7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-96d3-7500-a9d9-0c06a4803ac7",
        "storage_key": "property/6767906449166355/019fd811-96d3-7500-a9d9-0c06a4803ac7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://amorerestaurantpa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14334040592882819037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amore-restaurant",
      "poi_latitude": "40.1730069",
      "poi_longitude": "-74.83211639999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-943-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZU0lb5dRwYkR3V_PZvm97MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e0ca16ec-daa9-4691-a5c9-bfcff44a24f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Salvatore’s Cucina",
      "poi_type": "Restaurants",
      "poi_address": "1150 Bristol Oxford Valley Rd, Levittown, PA 19057, USA",
      "poi_short_description": "Casual, comfortable eatery specializing in Italian meals such as veal and buffalo chicken, plus pizza.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-9a39-779b-8cec-51337072c207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-9a39-779b-8cec-51337072c207",
        "storage_key": "property/6767906449166355/019fd811-9a39-779b-8cec-51337072c207.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.salvatorescucina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16576051410330909839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salvatores-cucina",
      "poi_latitude": "40.1653579",
      "poi_longitude": "-74.8756532",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-547-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5HoldVTwYkRj_xiG-_2CeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_45badc0d-bdef-4cab-b4fd-00c5a7d544ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Gleasons Bar",
      "poi_type": "Restaurants",
      "poi_address": "6700 Mill Creek Rd, Levittown, PA 19057, USA",
      "poi_short_description": "Informal bar offering cheesesteaks, wings, and other bites, plus live entertainment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-9c6c-72c9-968c-fd4e7966ba0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-9c6c-72c9-968c-fd4e7966ba0e",
        "storage_key": "property/6767906449166355/019fd811-9c6c-72c9-968c-fd4e7966ba0e.webp",
        "width": 726,
        "height": 960
      },
      "poi_business_url": "https://gleasonsbarandsteaks.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593197869003018045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gleasons-bar",
      "poi_latitude": "40.139373",
      "poi_longitude": "-74.8493639",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-943-4781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e51f-709e-af8f-1105bd5a8985.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e51f-709e-af8f-1105bd5a8985",
        "storage_key": "property/6767906449166355/019fce10-e51f-709e-af8f-1105bd5a8985.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3-nm-r9RwYkRPY_Jk4e-f1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e18f5a58-179d-4b3b-a012-b5433e20ae63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Ponticelli Pizzeria & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1502 Haines Rd, Levittown, PA 19055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-9ece-76b1-8e69-cafbb7d2b5b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-9ece-76b1-8e69-cafbb7d2b5b0",
        "storage_key": "property/6767906449166355/019fd811-9ece-76b1-8e69-cafbb7d2b5b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ponticellipizzeriapa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312034799396665830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponticelli-pizzeria--restaurant",
      "poi_latitude": "40.1336494",
      "poi_longitude": "-74.8304807",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-946-5780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG5-iB8tRwYkR5jnFJRq29i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a1dde05-69f6-40a2-b7e3-12f9ab607713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Mauricio’s Pizza & Grill",
      "poi_type": "Restaurants",
      "poi_address": "7012 Mill Creek Rd, Levittown, PA 19057, USA",
      "poi_short_description": "Pizza, cheesesteaks, hoagies, and more offered by a casual joint with late-night hours and delivery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-ca0c-736d-84a2-8a13b7acc7fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-ca0c-736d-84a2-8a13b7acc7fd",
        "storage_key": "property/6767906449166355/019fd811-ca0c-736d-84a2-8a13b7acc7fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pizzaandgrillonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12003641209249667810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mauricios-pizza--grill",
      "poi_latitude": "40.1413912",
      "poi_longitude": "-74.84669579999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-945-2101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOeqf7L5RwYkR4hqR8BSAlaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a5be5899-c337-4b77-920f-b4ed098ce1b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Ariana's Pizzeria & Italian",
      "poi_type": "Restaurants",
      "poi_address": "230 Levittown Pkwy, Levittown, PA 19054, USA",
      "poi_short_description": "Local pizzeria offering a variety of pies, including the popular Sicilian, plus wings and other Italian dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-a1e5-7001-b12e-f37689246521.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-a1e5-7001-b12e-f37689246521",
        "storage_key": "property/6767906449166355/019fd811-a1e5-7001-b12e-f37689246521.webp",
        "width": 1099,
        "height": 600
      },
      "poi_business_url": "https://www.arianaspizzeriaitalian.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17118121932506264465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arianas-pizzeria--italian",
      "poi_latitude": "40.1450698",
      "poi_longitude": "-74.8204724",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-949-8785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWMw61RQwYkRkfPbsDPJj-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_abcd5d26-b954-43c3-a56c-47b15289b15b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Julio's Famous Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "515 S Oxford Valley Rd, Fairless Hills, PA 19030, USA",
      "poi_short_description": "Relaxed, family-run outfit offering thin-crust pies, cheesesteaks & pasta for dine-in or takeout.",
      "poi_long_description": "Relaxed, family-run outfit offering thin-crust pies, cheesesteaks & pasta for dine-in or takeout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-a407-771e-a643-561f6045e8dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-a407-771e-a643-561f6045e8dc",
        "storage_key": "property/6767906449166355/019fd811-a407-771e-a643-561f6045e8dc.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://juliosfamouspizzeria.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6584684459155289875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julios-famous-pizzeria",
      "poi_latitude": "40.1697482",
      "poi_longitude": "-74.8489769",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-945-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuWqUYQ1RwYkRE3f84aB_YVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30fbf99c-7c90-4405-9871-6c75740b3410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Stadium Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "506 Hood Blvd, Fairless Hills, PA 19030, USA",
      "poi_short_description": "Multiple TVs, burgers & other pub fare in a bustling sports-watching destination.",
      "poi_long_description": "Multiple TVs, burgers & other pub fare in a bustling sports-watching destination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-a7f8-7778-b87f-13882402c339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-a7f8-7778-b87f-13882402c339",
        "storage_key": "property/6767906449166355/019fd811-a7f8-7778-b87f-13882402c339.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.thestadiums.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17560122798631038130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stadium-bar--grill",
      "poi_latitude": "40.1724931",
      "poi_longitude": "-74.8470693",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-946-0157",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e51f-709e-af8f-1105bd5a8985.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e51f-709e-af8f-1105bd5a8985",
        "storage_key": "property/6767906449166355/019fce10-e51f-709e-af8f-1105bd5a8985.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLe7V9hNRwYkRsiyk2KUWsvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1e4ae391-1afb-4b23-8f6a-be08c8e95ae7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Giovanni's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "928 Woodbourne Rd, Levittown, PA 19057, USA",
      "poi_short_description": "Easygoing chain pizzeria supplying custom pies, plus pastas, sandwiches & sides.",
      "poi_long_description": "Easygoing chain pizzeria supplying custom pies, plus pastas, sandwiches & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-d44f-725c-a671-2c37798ba63a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-d44f-725c-a671-2c37798ba63a",
        "storage_key": "property/6767906449166355/019fd811-d44f-725c-a671-2c37798ba63a.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.giovannispizzaoflevittown.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13057268681513762949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giovannis-pizza",
      "poi_latitude": "40.1690957",
      "poi_longitude": "-74.8788355",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-945-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-cO8tZTwYkRhQB2eq-8NLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eb95ee47-6fb1-43f7-ad7c-92f014314183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "V&S Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "415 S Oxford Valley Rd, Fairless Hills, PA 19030, USA",
      "poi_short_description": "Long-standing family-owned pizzeria making pies with homemade dough plus cheesesteaks and other items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-ad70-7092-98d7-edb5711b5ed3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-ad70-7092-98d7-edb5711b5ed3",
        "storage_key": "property/6767906449166355/019fd811-ad70-7092-98d7-edb5711b5ed3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vs-pizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14148685601505986247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vs-pizzeria",
      "poi_latitude": "40.1722083",
      "poi_longitude": "-74.8523472",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-945-6671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4vJIW1RwYkRx8ZydJc6WsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f8bdd1ff-bf03-4329-b946-c4e6bc14eeb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "ACME Markets",
      "poi_type": "Shopping & Retail",
      "poi_address": "6800 New Falls Rd, Levittown, PA 19057, USA",
      "poi_short_description": "Clean supermarket, deli, bakery and pharmacy offering meat and seafood.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-b296-7779-bef7-0f3ae76997ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-b296-7779-bef7-0f3ae76997ca",
        "storage_key": "property/6767906449166355/019fd811-b296-7779-bef7-0f3ae76997ca.webp",
        "width": 1070,
        "height": 601
      },
      "poi_business_url": "https://local.acmemarkets.com/pa/levittown/6800-new-falls-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5713046835966249379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acme-markets",
      "poi_latitude": "40.1517478",
      "poi_longitude": "-74.8571626",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-946-1840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e593-74dd-8b57-e15bb7307a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e593-74dd-8b57-e15bb7307a46",
        "storage_key": "property/6767906449166355/019fce10-e593-74dd-8b57-e15bb7307a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-y_xZtRwYkRownwCtTRSE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_57b6ef72-3523-4c10-98a7-3dafa74e5346",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "GIANT",
      "poi_type": "Shopping & Retail",
      "poi_address": "4001 New Falls Rd, Levittown, PA 19056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-b8df-713f-bcf4-12631b502407.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-b8df-713f-bcf4-12631b502407",
        "storage_key": "property/6767906449166355/019fd811-b8df-713f-bcf4-12631b502407.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.giantfoodstores.com/pa/levittown/4001-new-falls-rd?y_source=1_NDE5NTY0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13823478963217743079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant",
      "poi_latitude": "40.134389",
      "poi_longitude": "-74.88588090000002",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-949-1408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e593-74dd-8b57-e15bb7307a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e593-74dd-8b57-e15bb7307a46",
        "storage_key": "property/6767906449166355/019fce10-e593-74dd-8b57-e15bb7307a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLw-wChBSwYkR57ytiuDc1r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_da710da0-f846-419a-91da-25e2ac306ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2990 Edgely Rd, Levittown, PA 19057, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-bfb1-719b-8a33-ce4ee958548a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-bfb1-719b-8a33-ce4ee958548a",
        "storage_key": "property/6767906449166355/019fd811-bfb1-719b-8a33-ce4ee958548a.webp",
        "width": 1280,
        "height": 902
      },
      "poi_business_url": "https://stores.aldi.us/pa/levittown/2990-edgely-road?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=13618471830089469796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.1420979",
      "poi_longitude": "-74.8449895",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e593-74dd-8b57-e15bb7307a46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e593-74dd-8b57-e15bb7307a46",
        "storage_key": "property/6767906449166355/019fce10-e593-74dd-8b57-e15bb7307a46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2_Tur5RwYkRZI8lyPmH_rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9924b6ad-73f3-4b4b-89fe-7dcb184aadef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "4214 Woodbourne Rd, Levittown, PA 19057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-c59a-734a-b7ee-582bd899d7c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-c59a-734a-b7ee-582bd899d7c3",
        "storage_key": "property/6767906449166355/019fd811-c59a-734a-b7ee-582bd899d7c3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/levittown-pa-pharmacies/4214-woodbourne-rd-levittown-pa-19057/storeid=2554?WT.mc_id=LS_GOOGLE_RX_2554",
      "poi_directions_map_url": "https://maps.google.com/?cid=9378153200624029662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.1548381",
      "poi_longitude": "-74.85630909999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-269-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9f1-746f-b3e3-b5d6e7d05cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9f1-746f-b3e3-b5d6e7d05cbc",
        "storage_key": "property/6767906449166355/019fce10-e9f1-746f-b3e3-b5d6e7d05cbc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0k_r55RwYkR3k9j_KXkJYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1c16bfcd-2456-4c8d-982d-b0cc5e66528c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "8500 New Falls Rd, Levittown, PA 19054, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-cbf9-7187-a25c-12a186dcba66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-cbf9-7187-a25c-12a186dcba66",
        "storage_key": "property/6767906449166355/019fd811-cbf9-7187-a25c-12a186dcba66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8500+new+falls+rd-levittown-pa-19054/id=2014",
      "poi_directions_map_url": "https://maps.google.com/?cid=1251390689033449183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.1656165",
      "poi_longitude": "-74.8408614",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-943-3694",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2j49BpRwYkR3-4RlzPVXRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a07f268-fc52-463b-8dd4-6bb288f9273f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "8606 New Falls Rd, Levittown, PA 19054, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-d133-770d-ae50-bde77511e234.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-d133-770d-ae50-bde77511e234",
        "storage_key": "property/6767906449166355/019fd811-d133-770d-ae50-bde77511e234.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/levittown/8606-new-falls-rd-11379?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9717646879727262640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.1724176",
      "poi_longitude": "-74.8328247",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-943-9353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ea9e-73ca-ba31-08d75ad1d26b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ea9e-73ca-ba31-08d75ad1d26b",
        "storage_key": "property/6767906449166355/019fce10-ea9e-73ca-ba31-08d75ad1d26b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJX0xaRRlRwYkRsJvTzlkE3IY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_960d4c58-9de2-42d2-9069-cf8e638ed953",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "7625 New Falls Rd, Levittown, PA 19055, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-d0b9-7778-afbe-835f9ecd7045.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-d0b9-7778-afbe-835f9ecd7045",
        "storage_key": "property/6767906449166355/019fd811-d0b9-7778-afbe-835f9ecd7045.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/8004?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=10174703876815558863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "40.1601217",
      "poi_longitude": "-74.84915459999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-949-2401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e524-775c-a2a1-723ca1ca979e",
        "storage_key": "property/6767906449166355/019fce10-e524-775c-a2a1-723ca1ca979e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNTOdpApRwYkRz5hhoETPM40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9fcf598b-3564-46ac-b987-88ba9232b51c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Penn Valley Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8606 New Falls Rd, Levittown, PA 19054, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-d6f3-71cf-8f86-cf09e3e9a19e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-d6f3-71cf-8f86-cf09e3e9a19e",
        "storage_key": "property/6767906449166355/019fd811-d6f3-71cf-8f86-cf09e3e9a19e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1231721916084847316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-valley-shopping-center",
      "poi_latitude": "40.1726442",
      "poi_longitude": "-74.8326191",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ea87-761f-b41f-5e5d3b93db93",
        "storage_key": "property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAQAAyR5RwYkR1AJNho70FxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a267d2e0-bc99-439e-9754-8d15110e424c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Levittown Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "145 Levittown Pkwy, Levittown, PA 19054, USA",
      "poi_short_description": "Mall offering a variety of stores, including a pet shop, and a restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-d68b-77fc-a0ff-ab57e5e2a96b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-d68b-77fc-a0ff-ab57e5e2a96b",
        "storage_key": "property/6767906449166355/019fd811-d68b-77fc-a0ff-ab57e5e2a96b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dlcmgmt.com/property-search/#/property/90db9da4fc5414ab55a9fe495d555c06-5447ecd480f6cdf909b180e5dd3687de",
      "poi_directions_map_url": "https://maps.google.com/?cid=16719168925501971820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levittown-town-center",
      "poi_latitude": "40.1417538",
      "poi_longitude": "-74.8211978",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-502-6084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ea87-761f-b41f-5e5d3b93db93",
        "storage_key": "property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1THwNFJQwYkRbF1LSI5rBug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_88783007-8760-4fc4-bfd4-3d4bbe96ad7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Oxford Valley Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 E Lincoln Hwy, Langhorne, PA 19047, USA",
      "poi_short_description": "2-story mall since 1973, with department stores, a food court, kids' play area & nursing lounge.",
      "poi_long_description": "2-story mall since 1973, with department stores, a food court, kids' play area & nursing lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-ff76-76e9-a941-36a3c3f13578.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0f-ff76-76e9-a941-36a3c3f13578",
        "storage_key": "property/6767906449166355/019fce0f-ff76-76e9-a941-36a3c3f13578.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/oxford-valley-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=14706460198924046559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-valley-mall",
      "poi_latitude": "40.18381590000001",
      "poi_longitude": "-74.88062409999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-752-0221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ea87-761f-b41f-5e5d3b93db93",
        "storage_key": "property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoz3RSOdTwYkR39BJ_KHXF8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2fd19aea-ae71-4006-bdcb-fa123be0651b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Fairless Hills YMCA",
      "poi_type": "Education",
      "poi_address": "601 S Oxford Valley Rd, Fairless Hills, PA 19030, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-d8f9-74a2-a356-dd382b1ff3d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-d8f9-74a2-a356-dd382b1ff3d8",
        "storage_key": "property/6767906449166355/019fd811-d8f9-74a2-a356-dd382b1ff3d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ymcarivercrossing.org/locations/fairless-hills?utm_source=google&utm_medium=local&utm_campaign=gbp_fairless-hills",
      "poi_directions_map_url": "https://maps.google.com/?cid=12090417212549321262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairless-hills-ymca",
      "poi_latitude": "40.16705899999999",
      "poi_longitude": "-74.844642",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-949-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-eeff-76c5-91b0-7dfd1d9cb507",
        "storage_key": "property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN5LhCw5RwYkRLlJFpGXKyac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_72d97aa7-4e7e-47f3-b3b2-b690eb9ee6b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Bucks County Community College",
      "poi_type": "Education",
      "poi_address": "1304 Veterans Hwy, Bristol, PA 19007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-dbc7-7220-ab7a-6960be071044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-dbc7-7220-ab7a-6960be071044",
        "storage_key": "property/6767906449166355/019fd811-dbc7-7220-ab7a-6960be071044.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bucks.edu/campus/lbc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1329569734629254331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bucks-county-community-college-gene-and-marlene-epstein-campus-at-lower-bucks",
      "poi_latitude": "40.1127606",
      "poi_longitude": "-74.876588",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 267-685-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-eeff-76c5-91b0-7dfd1d9cb507",
        "storage_key": "property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI_Mqp-NNwYkRu-SvGKGUcxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_22fa5349-bb15-4a00-90cc-3e84e4a195ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Penco Tech",
      "poi_type": "Education",
      "poi_address": "3815 Otter St, Bristol, PA 19007",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "40.0979173",
      "poi_longitude": "-74.8710277",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e70cdd34-86b7-4f5f-aa72-74d55b099399",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Sesame Place Philadelphia",
      "poi_type": "Entertainment",
      "poi_address": "100 Sesame Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "Big Sesame Street-themed amusement park with rides, interactive parade, water slides & Elmo's World.",
      "poi_long_description": "Big Sesame Street-themed amusement park with rides, interactive parade, water slides & Elmo's World.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-dc4c-736f-8266-5d006cc0bbd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-dc4c-736f-8266-5d006cc0bbd1",
        "storage_key": "property/6767906449166355/019fd811-dc4c-736f-8266-5d006cc0bbd1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sesameplace.com/philadelphia?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12855531197120927059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sesame-place-philadelphia",
      "poi_latitude": "40.186117",
      "poi_longitude": "-74.8729972",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-702-3566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx22iKVlRwYkRU1VYI4MFaLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_237d3461-f936-4bc2-ba4f-5e895c13682b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Parx Casino",
      "poi_type": "Entertainment",
      "poi_address": "2999 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "\"Racino\" offers live horse racing, slots, table games & poker, with a variety of restaurants & bars.",
      "poi_long_description": "\"Racino\" offers live horse racing, slots, table games & poker, with a variety of restaurants & bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-de01-730b-8a5a-6a1561be6d2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-de01-730b-8a5a-6a1561be6d2a",
        "storage_key": "property/6767906449166355/019fd811-de01-730b-8a5a-6a1561be6d2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.parxcasino.com/?utm_source=GoogleMyBusiness&utm_medium=GMB&utm_campaign=2019",
      "poi_directions_map_url": "https://maps.google.com/?cid=9768216460368420707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parx-casino",
      "poi_latitude": "40.1184168",
      "poi_longitude": "-74.9530825",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 888-588-7279",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4O6WEhNwYkRYx9i0R2tj4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c38d1844-83ff-4654-a6e2-492b39095591",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "AMC Neshaminy 24",
      "poi_type": "Entertainment",
      "poi_address": "660 Neshaminy Mall, Bensalem, PA 19020, USA",
      "poi_short_description": "Chain multiplex featuring IMAX and Dolby sound systems, plus spacious seating and reclining chairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-e159-75f8-890e-b8b221227fe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-e159-75f8-890e-b8b221227fe6",
        "storage_key": "property/6767906449166355/019fd811-e159-75f8-890e-b8b221227fe6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/philadelphia/amc-neshaminy-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12053056166840425714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-neshaminy-24",
      "poi_latitude": "40.140225",
      "poi_longitude": "-74.954105",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-396-8050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-eed6-7223-8232-5f1cbea96567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-eed6-7223-8232-5f1cbea96567",
        "storage_key": "property/6767906449166355/019fce10-eed6-7223-8232-5f1cbea96567.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRjHmK5SwYkR8txaUrkORac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_735856ee-6593-44d5-9031-ac64bcb9bc80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Regal UA Oxford Valley",
      "poi_type": "Entertainment",
      "poi_address": "403 Middletown Blvd, Langhorne, PA 19047, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-e190-701a-9a0a-54494b04edac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-e190-701a-9a0a-54494b04edac",
        "storage_key": "property/6767906449166355/019fd811-e190-701a-9a0a-54494b04edac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-ua-oxford-valley-1269?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17691335440541601199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-ua-oxford-valley",
      "poi_latitude": "40.185394",
      "poi_longitude": "-74.88342",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-eed6-7223-8232-5f1cbea96567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-eed6-7223-8232-5f1cbea96567",
        "storage_key": "property/6767906449166355/019fce10-eed6-7223-8232-5f1cbea96567.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRFpuuZTwYkRr83Ct9k_hPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63e3ba07-fbab-4d37-92b6-0258cbef8495",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Shady Brook Farm",
      "poi_type": "Entertainment",
      "poi_address": "931 Stony Hill Rd, Yardley, PA 19067, USA",
      "poi_short_description": "Known for its seasonal events & U-pick, this quaint farm also features a market, deli & nursery.",
      "poi_long_description": "Known for its seasonal events & U-pick, this quaint farm also features a market, deli & nursery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-e352-7470-8515-38b987f54c0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-e352-7470-8515-38b987f54c0b",
        "storage_key": "property/6767906449166355/019fd811-e352-7470-8515-38b987f54c0b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://shadybrookfarm.com/?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=6619638797124315259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shady-brook-farm",
      "poi_latitude": "40.2281397",
      "poi_longitude": "-74.8852308",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-968-1670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmW-GQyNUwYkReyj942mu3Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_405418f1-1db2-4924-bed8-3c5ead32b04e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Bristol Riverside Theatre",
      "poi_type": "Entertainment",
      "poi_address": "120 Radcliffe St, Bristol, PA 19007, USA",
      "poi_short_description": "Professional theater set in a riverfront space, presenting new & enduring plays & musicals.",
      "poi_long_description": "Professional theater set in a riverfront space, presenting new & enduring plays & musicals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-e65e-7753-84b0-1890e6e0cf90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-e65e-7753-84b0-1890e6e0cf90",
        "storage_key": "property/6767906449166355/019fd811-e65e-7753-84b0-1890e6e0cf90.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://www.brtstage.org/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=12813162380549826293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bristol-riverside-theatre",
      "poi_latitude": "40.0949218",
      "poi_longitude": "-74.8555548",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-785-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl15c72tOwYkR9SYSTkx_0bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5566f2a6-7988-41d5-a905-bdbbc1c53704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Newtown Theatre",
      "poi_type": "Entertainment",
      "poi_address": "120 N State St, Newtown, PA 18940, USA",
      "poi_short_description": "Charming entertainment venue featuring live shows, screenings and private events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-e6c6-74ec-b392-b7884495a378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-e6c6-74ec-b392-b7884495a378",
        "storage_key": "property/6767906449166355/019fd811-e6c6-74ec-b392-b7884495a378.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://thenewtowntheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8756006225444591483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newtown-theatre",
      "poi_latitude": "40.2312186",
      "poi_longitude": "-74.9367194",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqer4xexUwYkRe9e7TkWVg3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8cab470-4b32-4971-bc74-01873d6e551f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "The Langhorne Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "1558 W Maple Ave, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-e84c-75c4-9fc4-824027673d6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-e84c-75c4-9fc4-824027673d6a",
        "storage_key": "property/6767906449166355/019fd811-e84c-75c4-9fc4-824027673d6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thelanghornebrewingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=852901655513389256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-langhorne-brewing-company",
      "poi_latitude": "40.1746059",
      "poi_longitude": "-74.94851659999999",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 267-689-0045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8cQSG2JTwYkRyNg3bYkd1gs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2c33d8a-78cb-4150-ae7c-319bd0570f77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Core Creek Park",
      "poi_type": "Entertainment",
      "poi_address": "901 Bridgetown Pike, Langhorne, PA 19047, USA",
      "poi_short_description": "Community area providing sports fields & courts, a playground, boating, fishing, lawns & a dog park.",
      "poi_long_description": "Community area providing sports fields & courts, a playground, boating, fishing, lawns & a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-3f6f-726c-bc23-912714dcd44e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce10-3f6f-726c-bc23-912714dcd44e",
        "storage_key": "property/6767906449166355/019fce10-3f6f-726c-bc23-912714dcd44e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.buckscounty.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12364559890853480857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "core-creek-park",
      "poi_latitude": "40.1950063",
      "poi_longitude": "-74.909577",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-757-0571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ef49-7798-9293-3ec5fb100527",
        "storage_key": "property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0WELeodTwYkRmUld4rW9l6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5902774e-7afa-4097-aff6-19973fd17f80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Pennsbury Manor",
      "poi_type": "Entertainment",
      "poi_address": "Pennsbury Manor State Park, 400 Pennsbury Memorial Rd, Morrisville, PA 19067, USA",
      "poi_short_description": "Reconstructed site features a riverside manor where visitors can experience 17th-century life.",
      "poi_long_description": "Reconstructed site features a riverside manor where visitors can experience 17th-century life.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-eb29-7387-8426-ce8e29b08518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-eb29-7387-8426-ce8e29b08518",
        "storage_key": "property/6767906449166355/019fd811-eb29-7387-8426-ce8e29b08518.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pennsburymanor.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15946394087225749764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennsbury-manor",
      "poi_latitude": "40.1328399",
      "poi_longitude": "-74.7682839",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-946-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ef5a-7078-8aaa-a487fc1cc49a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ef5a-7078-8aaa-a487fc1cc49a",
        "storage_key": "property/6767906449166355/019fce10-ef5a-7078-8aaa-a487fc1cc49a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYDWCZpawYkRBPF6Se_4TN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_70ab4e40-9fa3-428f-bc32-97c9c3ad4749",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "St. Mary Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 Langhorne Newtown Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-ebca-70ed-91d8-6ad0f507e0a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-ebca-70ed-91d8-6ad0f507e0a5",
        "storage_key": "property/6767906449166355/019fd811-ebca-70ed-91d8-6ad0f507e0a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.trinityhealthma.org/st-mary?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=main-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4473732539720751236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-mary-medical-center",
      "poi_latitude": "40.2023399",
      "poi_longitude": "-74.9250062",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 215-710-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f390-755c-8198-0a2ce8757e24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f390-755c-8198-0a2ce8757e24",
        "storage_key": "property/6767906449166355/019fce10-f390-755c-8198-0a2ce8757e24.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIQJHP3lTwYkRhFgpwgrkFT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_104579e4-010d-4e70-bfcf-346ff6526a26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "AFC Urgent Care Levittown",
      "poi_type": "Health and Wellness",
      "poi_address": "173 Levittown Pkwy #24a, Levittown, PA 19055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-eebf-75ea-8401-4018467ba774.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-eebf-75ea-8401-4018467ba774",
        "storage_key": "property/6767906449166355/019fd811-eebf-75ea-8401-4018467ba774.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.afcurgentcare.com/levittown/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-levittown-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6037794777674308590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-levittown",
      "poi_latitude": "40.1428769",
      "poi_longitude": "-74.8200288",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-648-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_aE5QwYkR7lv8VVyOylM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dfe0ca9f-e562-471e-bd02-f0e48b7aa142",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8500 New Falls Rd, Levittown, PA 19054, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-cbf9-7187-a25c-12a186dcba66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-cbf9-7187-a25c-12a186dcba66",
        "storage_key": "property/6767906449166355/019fd811-cbf9-7187-a25c-12a186dcba66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8500+new+falls+rd-levittown-pa-19054/id=2014",
      "poi_directions_map_url": "https://maps.google.com/?cid=1251390689033449183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.1656165",
      "poi_longitude": "-74.8408614",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-943-3694",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2j49BpRwYkR3-4RlzPVXRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6bbdcb37-6689-4e3e-b09a-0defe91739e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4214 Woodbourne Rd, Levittown, PA 19057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-c59a-734a-b7ee-582bd899d7c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-c59a-734a-b7ee-582bd899d7c3",
        "storage_key": "property/6767906449166355/019fd811-c59a-734a-b7ee-582bd899d7c3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/levittown-pa-pharmacies/4214-woodbourne-rd-levittown-pa-19057/storeid=2554?WT.mc_id=LS_GOOGLE_RX_2554",
      "poi_directions_map_url": "https://maps.google.com/?cid=9378153200624029662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.1548381",
      "poi_longitude": "-74.85630909999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-269-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9f1-746f-b3e3-b5d6e7d05cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9f1-746f-b3e3-b5d6e7d05cbc",
        "storage_key": "property/6767906449166355/019fce10-e9f1-746f-b3e3-b5d6e7d05cbc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0k_r55RwYkR3k9j_KXkJYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_570b6938-7869-45ef-9f52-f794c6811d2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Family 1 Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4005 Veterans Hwy, Levittown, PA 19056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-f33f-729c-9157-89903733205e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-f33f-729c-9157-89903733205e",
        "storage_key": "property/6767906449166355/019fd811-f33f-729c-9157-89903733205e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9286783165224728055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-1-pharmacy",
      "poi_latitude": "40.13221490000001",
      "poi_longitude": "-74.8843942",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-943-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9f1-746f-b3e3-b5d6e7d05cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9f1-746f-b3e3-b5d6e7d05cbc",
        "storage_key": "property/6767906449166355/019fce10-e9f1-746f-b3e3-b5d6e7d05cbc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-U1MQVSwYkR9zVM1RVI4YA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0167fe50-d7e1-4241-a1c4-d2f78c22f716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Nu Way Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1639 Haines Rd, Levittown, PA 19055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-f282-7516-8cd7-19ce9e3980d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-f282-7516-8cd7-19ce9e3980d1",
        "storage_key": "property/6767906449166355/019fd811-f282-7516-8cd7-19ce9e3980d1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.nuwaypharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5297189541960824678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nu-way-pharmacy",
      "poi_latitude": "40.1375282",
      "poi_longitude": "-74.8342296",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-547-0250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9f1-746f-b3e3-b5d6e7d05cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9f1-746f-b3e3-b5d6e7d05cbc",
        "storage_key": "property/6767906449166355/019fce10-e9f1-746f-b3e3-b5d6e7d05cbc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCwUnqstRwYkRZjd9nNJlg0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4fdab307-7805-44f7-9e89-927397820316",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1405 Lincoln Hwy, Levittown, PA 19056, USA",
      "poi_short_description": "Members-only chain gym in Langhorne Square Shopping Center offering tanning, with 24/7 access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-f368-73ee-a07f-9dfab0f6b642.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-f368-73ee-a07f-9dfab0f6b642",
        "storage_key": "property/6767906449166355/019fd811-f368-73ee-a07f-9dfab0f6b642.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/langhorne-pa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12015407969250777146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.1688321",
      "poi_longitude": "-74.89251039999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-949-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbOZfMlTwYkROhiXPuNNv6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_02364c0b-0159-4861-8124-e76b0c64b7d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Workout Anytime Levittown",
      "poi_type": "Health and Wellness",
      "poi_address": "153 Levittown Pkwy # 3, Levittown, PA 19055, USA",
      "poi_short_description": "Unfussy gym featuring 24/7 access and tanning beds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-f937-715b-8714-44427cfc7f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-f937-715b-8714-44427cfc7f1e",
        "storage_key": "property/6767906449166355/019fd811-f937-715b-8714-44427cfc7f1e.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "https://workoutanytime.com/location/levittown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2045306709237631842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "workout-anytime-levittown",
      "poi_latitude": "40.1405064",
      "poi_longitude": "-74.8210057",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-547-4525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE4u9o05QwYkRYgvVlJ1jYhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0166ece7-0bac-45b4-acaa-7444a9687372",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "FUEL HOUSE",
      "poi_type": "Health and Wellness",
      "poi_address": "1025-27 Bristol Oxford Valley Rd, Levittown, PA 19057, USA",
      "poi_short_description": "Membership-only workout space featuring intimate, boot camp-style classes & sports training.",
      "poi_long_description": "Membership-only workout space featuring intimate, boot camp-style classes & sports training.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-f935-725d-b4e2-450bcf7bacb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-f935-725d-b4e2-450bcf7bacb4",
        "storage_key": "property/6767906449166355/019fd811-f935-725d-b4e2-450bcf7bacb4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fuelhouse.fitness/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18147404069659855070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuel-house",
      "poi_latitude": "40.16663",
      "poi_longitude": "-74.8733227",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 610-312-8615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWDJ89VTwYkR3siNL9qH2Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_be3776ce-c34b-4b15-aabf-0cc223a6d44e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "The Prancing Peacock",
      "poi_type": "Health and Wellness",
      "poi_address": "524 Stony Hill Rd, Yardley, PA 19067, USA",
      "poi_short_description": "Studio offering Vinyasa, Yin, restorative & prenatal yoga classes, plus massage, meditation & reiki.",
      "poi_long_description": "Studio offering Vinyasa, Yin, restorative & prenatal yoga classes, plus massage, meditation & reiki.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-f9e0-77fb-a610-42acf8aaaae9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-f9e0-77fb-a610-42acf8aaaae9",
        "storage_key": "property/6767906449166355/019fd811-f9e0-77fb-a610-42acf8aaaae9.webp",
        "width": 1280,
        "height": 766
      },
      "poi_business_url": "http://prancingpeacock.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=132832869174570323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-prancing-peacock",
      "poi_latitude": "40.2185875",
      "poi_longitude": "-74.8577808",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 267-679-0791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-eeff-76c5-91b0-7dfd1d9cb507",
        "storage_key": "property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1QPXk7xWwYkRU22lbcrq1wE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7897907e-1c7e-43a4-9cdc-04cf4ad65495",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Falls Township Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9050 Mill Creek Rd, Levittown, PA 19054, USA",
      "poi_short_description": "Green space with facilities for ball games, skateboarding, boating & hockey, plus a dog run.",
      "poi_long_description": "Green space with facilities for ball games, skateboarding, boating & hockey, plus a dog run.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-fe0a-7388-b6ed-ade46b2021db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-fe0a-7388-b6ed-ade46b2021db",
        "storage_key": "property/6767906449166355/019fd811-fe0a-7388-b6ed-ade46b2021db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fallstwp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9189167481805791133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "falls-township-community-park",
      "poi_latitude": "40.157795",
      "poi_longitude": "-74.8087997",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-949-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ef49-7798-9293-3ec5fb100527",
        "storage_key": "property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq9VaqENRwYkRnd-abiN7hn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba76b1bd-2d96-4c7e-be45-7ceff6cf6d71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Core Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "901 Bridgetown Pike, Langhorne, PA 19047, USA",
      "poi_short_description": "Community area providing sports fields & courts, a playground, boating, fishing, lawns & a dog park.",
      "poi_long_description": "Community area providing sports fields & courts, a playground, boating, fishing, lawns & a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-3f6f-726c-bc23-912714dcd44e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce10-3f6f-726c-bc23-912714dcd44e",
        "storage_key": "property/6767906449166355/019fce10-3f6f-726c-bc23-912714dcd44e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.buckscounty.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12364559890853480857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "core-creek-park",
      "poi_latitude": "40.1950063",
      "poi_longitude": "-74.909577",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-757-0571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ef49-7798-9293-3ec5fb100527",
        "storage_key": "property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0WELeodTwYkRmUld4rW9l6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_780b6e04-9a9a-41aa-9c7c-6b8841da3f3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Neshaminy State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 State Rd., Bensalem, PA 19020, USA",
      "poi_short_description": "This 334-acre riverfront park offers fishing, walking paths, 2 seasonal pools & picnic pavilions.",
      "poi_long_description": "This 334-acre riverfront park offers fishing, walking paths, 2 seasonal pools & picnic pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-fe3a-706b-a322-209fa2424fcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-fe3a-706b-a322-209fa2424fcf",
        "storage_key": "property/6767906449166355/019fd811-fe3a-706b-a322-209fa2424fcf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dcnr.pa.gov/StateParks/FindAPark/NeshaminyStatePark/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7516380802006931726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neshaminy-state-park",
      "poi_latitude": "40.0784638",
      "poi_longitude": "-74.9228603",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ef49-7798-9293-3ec5fb100527",
        "storage_key": "property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNyQ2VlBMwYkRDlkwFISMT2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9358fb4f-52a9-4085-a51e-679c53683e79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Middletown Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2600 Langhorne Yardley Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "Skate park & basketball courts in an open park featuring playgrounds for young kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-ff4c-71ca-80ef-64330b50a903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-ff4c-71ca-80ef-64330b50a903",
        "storage_key": "property/6767906449166355/019fd811-ff4c-71ca-80ef-64330b50a903.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.middletownbucks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15814855716659765047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middletown-community-park",
      "poi_latitude": "40.21201",
      "poi_longitude": "-74.89047699999999",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-750-3890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ef49-7798-9293-3ec5fb100527",
        "storage_key": "property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWw9w7g5UwYkRN5-PzXuneds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ffdfde2b-9dab-4ded-b443-8715e79bb1c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Middletown Veterans' Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 Veterans Hwy, Levittown, PA 19056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-04cf-7499-89e0-ce55ee97910f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-04cf-7499-89e0-ce55ee97910f",
        "storage_key": "property/6767906449166355/019fd812-04cf-7499-89e0-ce55ee97910f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10006998293137812473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middletown-veterans-memorial-park",
      "poi_latitude": "40.1598178",
      "poi_longitude": "-74.8956884",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-750-3890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ef49-7798-9293-3ec5fb100527",
        "storage_key": "property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEyKjoUpSwYkR-Wtrou3_34o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_98c1f603-97b4-4b42-a7ab-8fdce782c04c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Tullytown Canal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Levittown, PA 19055, USA",
      "poi_short_description": "Park offering a playground and a path for walking and biking behind a Home Depot.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-04f7-77b0-b8f4-29d437c61bbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-04f7-77b0-b8f4-29d437c61bbe",
        "storage_key": "property/6767906449166355/019fd812-04f7-77b0-b8f4-29d437c61bbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6112638216800277079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tullytown-canal-park",
      "poi_latitude": "40.14171899999999",
      "poi_longitude": "-74.8239782",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ef49-7798-9293-3ec5fb100527",
        "storage_key": "property/6767906449166355/019fce10-ef49-7798-9293-3ec5fb100527.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUDDW0xQwYkRV5LbcBJ01FQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_77e2a2dd-5216-4ed4-84a5-6820407d755b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1338 Veterans Hwy, Levittown, PA 19056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15199304580865178762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playground",
      "poi_latitude": "40.1499451",
      "poi_longitude": "-74.8928641",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfbZlXABTwYkRirxvp_zG7tI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e1ec7afb-4acc-412c-a795-4ecee28a3a7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "The Mayors Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "215 E Richardson Ave, Langhorne, PA 19047, USA",
      "poi_short_description": "Informal, kid-friendly park with a playground, slides, swings, a soccer field and a jungle gym.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-05b2-75c7-b900-83b0d8e7c38e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-05b2-75c7-b900-83b0d8e7c38e",
        "storage_key": "property/6767906449166355/019fd812-05b2-75c7-b900-83b0d8e7c38e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://langhorneborough.com/departments/mayors-playground/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5372687405082509416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mayors-playground",
      "poi_latitude": "40.1759503",
      "poi_longitude": "-74.9168083",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0tVqahTwYkRaIAorbqej0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a3db92e1-e8f1-4058-8d88-0ba18684f5f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Langhorne Train Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1060 S Bellevue Ave, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-0b40-7369-b763-f346a57798a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-0b40-7369-b763-f346a57798a8",
        "storage_key": "property/6767906449166355/019fd812-0b40-7369-b763-f346a57798a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.septa.org/stations/langhorne-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=16113211080774150312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "langhorne-train-station",
      "poi_latitude": "40.160863",
      "poi_longitude": "-74.9131984",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-580-6941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f430-71cf-b76f-f3cd108c1ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f430-71cf-b76f-f3cd108c1ad8",
        "storage_key": "property/6767906449166355/019fce10-f430-71cf-b76f-f3cd108c1ad8.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWyAbFFSwYkRqGhuRBugnd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a495d9b-022b-45dd-86ac-c6d60bb038f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Septa Levittown-Tullytown Train Station Parking Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "129 Fallsington Ave #115, Tullytown, PA 19007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-0b87-7189-97d7-55fe779d9e08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-0b87-7189-97d7-55fe779d9e08",
        "storage_key": "property/6767906449166355/019fd812-0b87-7189-97d7-55fe779d9e08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://usmaplocation.org/business/septa-levittown-tullytown-train-station-parking-lo-p08af1",
      "poi_directions_map_url": "https://maps.google.com/?cid=9352288022262590545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "septa-levittown-tullytown-train-station-parking-lot",
      "poi_latitude": "40.1404522",
      "poi_longitude": "-74.8162649",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-946-4251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f430-71cf-b76f-f3cd108c1ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f430-71cf-b76f-f3cd108c1ad8",
        "storage_key": "property/6767906449166355/019fce10-f430-71cf-b76f-f3cd108c1ad8.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5U1Zk9QwYkRUSwa3GcAyoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c9095240-0af8-472f-a28d-e52a50d3cd9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Woodbourne",
      "poi_type": "Transportation & Transit",
      "poi_address": "Middletown Township, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-9fcf-7364-896a-41f084afd879.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce10-9fcf-7364-896a-41f084afd879",
        "storage_key": "property/6767906449166355/019fce10-9fcf-7364-896a-41f084afd879.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.septa.org/stations/rail/woodbourne.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6197462010909393844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodbourne",
      "poi_latitude": "40.1908953",
      "poi_longitude": "-74.8909783",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f3ed-7336-abed-a8059b2e4623.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f3ed-7336-abed-a8059b2e4623",
        "storage_key": "property/6767906449166355/019fce10-f3ed-7336-abed-a8059b2e4623.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJR0rmSe5TwYkRtIM7Bd3OAVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bdb1e795-3a5c-46af-b0ce-1f960df4008f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Neshaminy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bensalem Township, PA 19053, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026d-406d-76e6-88e7-3a17451868d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-406d-76e6-88e7-3a17451868d3",
        "storage_key": "property/6767906449166355/019d026d-406d-76e6-88e7-3a17451868d3.webp",
        "width": 943,
        "height": 678
      },
      "poi_business_url": "http://www.septa.org/stations/rail/neshaminyfalls.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2828999010508922625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neshaminy",
      "poi_latitude": "40.1469257",
      "poi_longitude": "-74.96213399999999",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f3ed-7336-abed-a8059b2e4623.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f3ed-7336-abed-a8059b2e4623",
        "storage_key": "property/6767906449166355/019fce10-f3ed-7336-abed-a8059b2e4623.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTy2yYbFSwYkRAd9Qg5yfQic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_64f0cd6f-a939-4e37-8744-6779b5cb11bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Oxford Valley Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "2300 E Lincoln Hwy, Langhorne, PA 19047, USA",
      "poi_short_description": "2-story mall since 1973, with department stores, a food court, kids' play area & nursing lounge.",
      "poi_long_description": "2-story mall since 1973, with department stores, a food court, kids' play area & nursing lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-ff76-76e9-a941-36a3c3f13578.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce0f-ff76-76e9-a941-36a3c3f13578",
        "storage_key": "property/6767906449166355/019fce0f-ff76-76e9-a941-36a3c3f13578.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/oxford-valley-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=14706460198924046559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-valley-mall",
      "poi_latitude": "40.18381590000001",
      "poi_longitude": "-74.88062409999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-752-0221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ea87-761f-b41f-5e5d3b93db93",
        "storage_key": "property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoz3RSOdTwYkR39BJ_KHXF8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2ff8950c-b508-40ce-888f-6f155e1ca798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Trenton Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "72 S Clinton Ave, Trenton, NJ 08609, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-0e51-73e2-87d3-f69bfa29d436.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-0e51-73e2-87d3-f69bfa29d436",
        "storage_key": "property/6767906449166355/019fd812-0e51-73e2-87d3-f69bfa29d436.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TRE",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253055944879228757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trenton-transit-center",
      "poi_latitude": "40.21879980000001",
      "poi_longitude": "-74.7543266",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f3ed-7336-abed-a8059b2e4623.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f3ed-7336-abed-a8059b2e4623",
        "storage_key": "property/6767906449166355/019fce10-f3ed-7336-abed-a8059b2e4623.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJj1lF_rZZwYkRVccfuMLiKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ee366ff3-4bbc-402c-bd4f-ee26f18754f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Trenton-Mercer Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1100 Terminal Cir Dr, Ewing Township, NJ 08628, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-10a0-74eb-865f-e7d301d334a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-10a0-74eb-865f-e7d301d334a3",
        "storage_key": "property/6767906449166355/019fd812-10a0-74eb-865f-e7d301d334a3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.flytrentonmercer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14865279647832479002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trenton-mercer-airport",
      "poi_latitude": "40.2770583",
      "poi_longitude": "-74.81811909999999",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 609-882-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f3ff-752a-9287-e07f3a6c9853.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f3ff-752a-9287-e07f3a6c9853",
        "storage_key": "property/6767906449166355/019fce10-f3ff-752a-9287-e07f3a6c9853.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJaUy3GmP9w4kRGhXmfxQVTM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9ae4e2d2-22a7-4659-a020-b7b3bc530b9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "8000 Essington Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "8000 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3940177627801768097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "8000-essington-ave",
      "poi_latitude": "39.8709941",
      "poi_longitude": "-75.26416499999999",
      "poi_miles_from_property": "40",
      "poi_walking_minutes": "14 hours 53 mins",
      "poi_biking_minutes": "3 hours 23 mins",
      "poi_driving_minutes": "49 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6RdEkLDxokRodAQMa1SrjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bf4ee578-3adc-401d-b7f7-2a3b10b67135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Lower Bucks Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 Bath Rd, Bristol, PA 19007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-10b2-722d-9270-3d920e58473f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-10b2-722d-9270-3d920e58473f",
        "storage_key": "property/6767906449166355/019fd812-10b2-722d-9270-3d920e58473f.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://lowerbuckshosp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10385465491232408324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lower-bucks-hospital",
      "poi_latitude": "40.1055711",
      "poi_longitude": "-74.8674966",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 215-785-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f390-755c-8198-0a2ce8757e24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f390-755c-8198-0a2ce8757e24",
        "storage_key": "property/6767906449166355/019fce10-f390-755c-8198-0a2ce8757e24.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpSLAGQxOwYkRBEP899aVIJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9b7cdde7-4b47-47c4-8e8b-51aaf44c4a80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "St. Mary Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 Langhorne Newtown Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-ebca-70ed-91d8-6ad0f507e0a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-ebca-70ed-91d8-6ad0f507e0a5",
        "storage_key": "property/6767906449166355/019fd811-ebca-70ed-91d8-6ad0f507e0a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.trinityhealthma.org/st-mary?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=main-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4473732539720751236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-mary-medical-center",
      "poi_latitude": "40.2023399",
      "poi_longitude": "-74.9250062",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 215-710-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f390-755c-8198-0a2ce8757e24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f390-755c-8198-0a2ce8757e24",
        "storage_key": "property/6767906449166355/019fce10-f390-755c-8198-0a2ce8757e24.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIQJHP3lTwYkRhFgpwgrkFT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e0147a2-9835-44ba-b7e6-8156022e03eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Woods Services and Woods System of Care",
      "poi_type": "Major Employers & Offices",
      "poi_address": "40 Martin Gross Dr, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-1518-76be-bd79-04a94528d808.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-1518-76be-bd79-04a94528d808",
        "storage_key": "property/6767906449166355/019fd812-1518-76be-bd79-04a94528d808.webp",
        "width": 1280,
        "height": 866
      },
      "poi_business_url": "http://www.woods.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4528934966245223408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woods-services-and-woods-system-of-care",
      "poi_latitude": "40.1749946",
      "poi_longitude": "-74.9081778",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-750-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYMYJaVTwYkR8GvkQVsC2j4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0105c7ad-0993-4265-8273-b23e933bfc88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Parx Casino",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2999 Street Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "\"Racino\" offers live horse racing, slots, table games & poker, with a variety of restaurants & bars.",
      "poi_long_description": "\"Racino\" offers live horse racing, slots, table games & poker, with a variety of restaurants & bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-de01-730b-8a5a-6a1561be6d2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-de01-730b-8a5a-6a1561be6d2a",
        "storage_key": "property/6767906449166355/019fd811-de01-730b-8a5a-6a1561be6d2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.parxcasino.com/?utm_source=GoogleMyBusiness&utm_medium=GMB&utm_campaign=2019",
      "poi_directions_map_url": "https://maps.google.com/?cid=9768216460368420707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parx-casino",
      "poi_latitude": "40.1184168",
      "poi_longitude": "-74.9530825",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 888-588-7279",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4O6WEhNwYkRYx9i0R2tj4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f9d18360-5f7c-4da9-905a-84b610e987d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Sesame Place Philadelphia",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Sesame Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "Big Sesame Street-themed amusement park with rides, interactive parade, water slides & Elmo's World.",
      "poi_long_description": "Big Sesame Street-themed amusement park with rides, interactive parade, water slides & Elmo's World.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-dc4c-736f-8266-5d006cc0bbd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-dc4c-736f-8266-5d006cc0bbd1",
        "storage_key": "property/6767906449166355/019fd811-dc4c-736f-8266-5d006cc0bbd1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sesameplace.com/philadelphia?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12855531197120927059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sesame-place-philadelphia",
      "poi_latitude": "40.186117",
      "poi_longitude": "-74.8729972",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-702-3566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx22iKVlRwYkRU1VYI4MFaLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_936d5e0e-b30c-4ade-bbfa-61474871c756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Crown Holdings Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "770 Township Line Rd, Morrisville, PA 19067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-18d2-77ac-a060-c8da258944f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-18d2-77ac-a060-c8da258944f0",
        "storage_key": "property/6767906449166355/019fd812-18d2-77ac-a060-c8da258944f0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.crowncork.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5150454131923874434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crown-holdings-inc",
      "poi_latitude": "40.2220605",
      "poi_longitude": "-74.88428139999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-698-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Soj-eSyxokRgvJDpb4Wekc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60a84abc-26f2-4e21-9e5d-7e61ee34c37d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "EPAM Systems",
      "poi_type": "Major Employers & Offices",
      "poi_address": "41 University Dr #202, Newtown, PA 18940, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-17d4-74ea-ab0b-ff4b03c09bca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-17d4-74ea-ab0b-ff4b03c09bca",
        "storage_key": "property/6767906449166355/019fd812-17d4-74ea-ab0b-ff4b03c09bca.webp",
        "width": 720,
        "height": 450
      },
      "poi_business_url": "http://www.epam.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11047024278800788157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "epam-systems",
      "poi_latitude": "40.2229169",
      "poi_longitude": "-74.9057697",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 267-759-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-e9ec-76fc-b63a-c4d31badcc5f",
        "storage_key": "property/6767906449166355/019fce10-e9ec-76fc-b63a-c4d31badcc5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBX_EBGlUwYkRvWoJSw3qTpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0ec3d8f4-e3d0-4d61-86b3-60cefb1756fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Bucks County Community College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1304 Veterans Hwy, Bristol, PA 19007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-dbc7-7220-ab7a-6960be071044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd811-dbc7-7220-ab7a-6960be071044",
        "storage_key": "property/6767906449166355/019fd811-dbc7-7220-ab7a-6960be071044.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bucks.edu/campus/lbc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1329569734629254331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bucks-county-community-college-gene-and-marlene-epstein-campus-at-lower-bucks",
      "poi_latitude": "40.1127606",
      "poi_longitude": "-74.876588",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 267-685-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-eeff-76c5-91b0-7dfd1d9cb507",
        "storage_key": "property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI_Mqp-NNwYkRu-SvGKGUcxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_454c365f-5613-4933-aabf-784e6144af58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Neshaminy School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2250 Langhorne Yardley Rd, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-1eda-734a-b22d-b1f8b8f8c726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-1eda-734a-b22d-b1f8b8f8c726",
        "storage_key": "property/6767906449166355/019fd812-1eda-734a-b22d-b1f8b8f8c726.webp",
        "width": 754,
        "height": 754
      },
      "poi_business_url": "http://www.neshaminy.k12.pa.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8517336675413603718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neshaminy-school-district",
      "poi_latitude": "40.2057932",
      "poi_longitude": "-74.8986132",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-809-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-eeff-76c5-91b0-7dfd1d9cb507",
        "storage_key": "property/6767906449166355/019fce10-eeff-76c5-91b0-7dfd1d9cb507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk3t7Q3VUwYkRhjVvWpSoM3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_85f714c5-6150-4196-a0f3-7a180d820df0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Major Employers & Offices",
      "poi_address": "180 Levittown Center, Levittown, PA 19055, USA",
      "poi_short_description": "Wide selection of clothing, appliances, electronics, housewares, toys and furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd812-1dd3-74a5-a4d0-cc29e5ea32f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd812-1dd3-74a5-a4d0-cc29e5ea32f7",
        "storage_key": "property/6767906449166355/019fd812-1dd3-74a5-a4d0-cc29e5ea32f7.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2068-levittown-pa/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3988477906212249341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "40.14207589999999",
      "poi_longitude": "-74.8225698",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-949-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-ea87-761f-b41f-5e5d3b93db93",
        "storage_key": "property/6767906449166355/019fce10-ea87-761f-b41f-5e5d3b93db93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6ULSRklQwYkR_V5GGobrWTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1fe86c89-f4d4-4e4d-813f-d2d5c2161196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Cairn University",
      "poi_type": "Education",
      "poi_address": "200 Manor Ave, Langhorne, PA 19047, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-d70c-7329-a46b-ff7853afb46b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce10-d70c-7329-a46b-ff7853afb46b",
        "storage_key": "property/6767906449166355/019fce10-d70c-7329-a46b-ff7853afb46b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://cairn.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3706033587535212510&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cairn-university",
      "poi_latitude": "40.1667208",
      "poi_longitude": "-74.9069734",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 215-752-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f8ad-74eb-9289-f4f276a965a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f8ad-74eb-9289-f4f276a965a3",
        "storage_key": "property/6767906449166355/019fce10-f8ad-74eb-9289-f4f276a965a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzUz2eVJSwYkR3u-zlul5bjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_28eae07f-6f9e-4c29-b41d-0861124ec5aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "poi_name": "Lincoln Technical Institute",
      "poi_type": "Education",
      "poi_address": "311 Veterans Hwy, Levittown, PA 19056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-d764-7318-94b2-fdd6bf0069d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce10-d764-7318-94b2-fdd6bf0069d0",
        "storage_key": "property/6767906449166355/019fce10-d764-7318-94b2-fdd6bf0069d0.webp",
        "width": 1280,
        "height": 440
      },
      "poi_business_url": "https://www.lincolntech.edu/campus/levittown-pa",
      "poi_directions_map_url": "https://maps.google.com/?cid=16343345151767177663&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lincoln-technical-institute",
      "poi_latitude": "40.162755",
      "poi_longitude": "-74.8991696",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-335-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-f8ad-74eb-9289-f4f276a965a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fce10-f8ad-74eb-9289-f4f276a965a3",
        "storage_key": "property/6767906449166355/019fce10-f8ad-74eb-9289-f4f276a965a3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ79j7qRVTwYkRv2mvJNM5z-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "custom_ecb61d28-7504-4942-8f62-8ce685add15e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fa9bc-fc76-7348-b253-7209e1bd3900.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa9bc-fc76-7348-b253-7209e1bd3900",
        "storage_key": "property/6767906449166355/019fa9bc-fc76-7348-b253-7209e1bd3900.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": " 360 Tours",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6352d9d25e8d0d70df2a5bd6&sourceId=1001"
    },
    {
      "id": "custom_98d9ffb1-3358-4116-bde0-33f959280f24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-6bc8-767d-9d2f-da598e386c85.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with white cabinets, a large island, and stainless steel appliances.",
        "public_id": "019d026e-6bc8-767d-9d2f-da598e386c85",
        "storage_key": "property/6767906449166355/019d026e-6bc8-767d-9d2f-da598e386c85.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 BR 2 BA - The Residences at St. Joseph Court",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CfJ73chdaXa&play=1"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_3b0fef9e55cab5611dcd52f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429680",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4c5a7951a71b7040c5ceae3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429681",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5321d5c9ddc0175bc48c58cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429682",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_84ce1852d83c0edec89d3cf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429684",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d7e0e7b4307f381b4e08806d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429687",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5528fe4ead07b9f93d9be02e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429688",
      "name": "Pet Fee",
      "description": "false",
      "amount": 300,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_442db8da5ba295b27d560db3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429689",
      "name": "Storage Space-Small",
      "description": "false",
      "amount": 55,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "storage",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_23c4ebc02d96fe151192c653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429690",
      "name": "Storage Space- Large",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "storage",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a4e80367826506783d738e8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "429691",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_df09707eb95bfd9dac65c22a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "514390",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 50,
      "amount_max": 60,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_951fb4b48bb5307b87eb4ad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "572096",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e9bc6eea45bea4a42a7f8fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "572097",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6bb47bf5bc52aa3816caf78b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "835289",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_53bf43bca0b594a962ffccaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "835295",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7c1ae17e89aac3445a17bda0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "835297",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_03dfcef5cf2c78247021878f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "835303",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_23838f0c54fd78002b18ffb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "835309",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e9d9a2dba0d62dce8943f87d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "engrain",
      "external_id": "947411",
      "name": "Trash Service",
      "description": "false",
      "amount": 5,
      "amount_max": 8,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1712-6398-7089-bcf2-306012a75560",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-the-residences-at-st-josephs-court-55-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355"
    },
    {
      "lead_collector_id": "019c3043-b449-735e-84e4-fffce49291f2",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-residences-at-st-josephs-court",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355"
    },
    {
      "lead_collector_id": "019c3043-b4b9-710d-87f2-156d05dccbd5",
      "lead_source": "LANDING_PAGE",
      "name": "the-residences-at-st-josephs-court",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "apartments-in-unit-laundry-levittown-pa-915",
      "search_query": "apartments with in unit laundry Levittown PA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Levittown, PA",
      "h2_subtitle": "Discover apartment living with the convenience of in-unit laundry. In Levittown, PA, our community offers unmatched comfort and modern style.",
      "page_copy": "The Residences at St. Joseph's Court 55+ in Levittown, PA, is the perfect choice for those seeking apartments with in-unit laundry. Our thoughtfully designed one and two-bedroom floor plans provide the ultimate convenience right within your home. Imagine the ease of managing laundry tasks without leaving the comfort of your apartment.\n\nBeyond the convenience of in-unit laundry, our community features upscale amenities such as a state-of-the-art fitness center, sleek stainless steel appliances, and inviting social spaces. With hardwood floors and an office space to accommodate modern lifestyles, The Residences at St. Joseph's Court offer not just a place to live, but a place to thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Levittown Apartments with In-Unit Laundry",
      "seo_description": "Explore apartments with in-unit laundry in Levittown, PA. Enjoy modern elegance and spacious comfort at The Residences at St. Joseph's Court 55+.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-bucks-county-766",
      "search_query": "air conditioned apartments in Bucks County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Bucks County",
      "h2_subtitle": "Enjoy comfort year-round in air conditioned apartments. Explore modern living in Bucks County with ideal temperature control.",
      "page_copy": "Step into comfort at The Residences at St. Joseph's Court 55+ in Bucks County, where air conditioned apartments offer you a serene escape. Our one and two-bedroom floor plans are designed with your comfort in mind, ensuring you stay cool during the warmer months while relishing in the modern amenities we offer.\n\nBeyond air conditioning, indulge in a community that caters to an active lifestyle with features like a cutting-edge fitness center and social spaces. Spacious layouts equipped with stainless steel appliances and hardwood floors create an environment of contemporary elegance. Discover a balanced lifestyle at The Residences at St. Joseph's Court, where your comfort is our priority.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Bucks County",
      "seo_description": "Find air conditioned apartments in Bucks County at The Residences at St. Joseph's Court 55+. Experience cool comfort and modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "senior-living-dishwasher-thornridge-699",
      "search_query": "senior living with dishwasher in Thornridge",
      "category": "Amenity",
      "h1_title": "Senior Living with Dishwasher in Thornridge",
      "h2_subtitle": "Experience senior living with the convenience of a dishwasher. Nestled in Thornridge, enjoy a modern lifestyle designed for ease.",
      "page_copy": "At The Residences at St. Joseph's Court 55+ in Thornridge, senior living meets convenience with features like in-home dishwashers. Each thoughtfully crafted one and two-bedroom apartment allows you to enjoy easy meal clean-up, giving you more time to relax and enjoy your day.\n\nIn addition to in-unit dishwashers, our community provides a range of amenities designed for an enriched living experience. From hardwood floors and stainless steel appliances to a modern fitness center, you’ll find everything you need to enjoy an active, fulfilling lifestyle. Become part of our welcoming community at The Residences at St. Joseph's Court in Thornridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Senior Living with Dishwasher in Thornridge",
      "seo_description": "Discover senior living with a dishwasher in Thornridge. Enjoy modern amenities at The Residences at St. Joseph's Court 55+.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-levittown-19054-396",
      "search_query": "fitness center apartments Levittown 19054",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Levittown 19054",
      "h2_subtitle": "Find your active lifestyle at apartments with a fitness center. Located in Levittown, PA 19054, our community offers convenience and style.",
      "page_copy": "The Residences at St. Joseph's Court 55+ in Levittown, PA 19054, offers fitness enthusiasts the chance to live in comfort while maintaining an active lifestyle. Our state-of-the-art fitness center is available for residents, making it easy to integrate exercise into your daily routine. Enjoy the convenience of working out close to home.\n\nOur spacious one and two-bedroom apartments come paired with upscale amenities like stainless steel appliances, hardwood floors, and inviting social areas. Discover the perfect blend of activity and relaxation at The Residences, where well-designed spaces meet modern comforts in the heart of Levittown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Levittown 19054 Apartments with Fitness Center",
      "seo_description": "Explore Levittown 19054 apartments with a fitness center. Enjoy a modern lifestyle at The Residences at St. Joseph's Court 55+.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "granite-countertop-kitchens-levittown-senior-apartments-763",
      "search_query": "granite countertop kitchens in Levittown senior apartments",
      "category": "Amenity",
      "h1_title": "Granite Countertop Kitchens in Levittown Senior Apartments",
      "h2_subtitle": "Discover senior apartments with granite countertop kitchens. Located in Levittown, our community combines beauty and functionality.",
      "page_copy": "At The Residences at St. Joseph's Court 55+ in Levittown, enjoy the elegance of granite countertop kitchens in our meticulously designed senior apartments. Each kitchen not only enhances the aesthetic appeal of your home but also offers a durable and easy-to-maintain cooking space that simplifies everyday life.\n\nImmerse yourself in a community that supports your lifestyle with amenities ranging from stainless steel appliances and hardwood floors to a modern fitness center. Nestled in the welcoming Levittown area, The Residences at St. Joseph's Court provides a superb living experience uniquely curated for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Levittown Senior Apartments with Granite Countertops",
      "seo_description": "Find Levittown senior apartments with granite countertop kitchens. Enjoy elegance and comfort at The Residences at St. Joseph's Court 55+.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-levittown-pa-981",
      "search_query": "one bedroom apartments Levittown PA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Levittown, PA",
      "h2_subtitle": "Explore spacious one bedroom apartments in Levittown. Enjoy modern living with designed spaces perfect for comfort and style.",
      "page_copy": "At The Residences at St. Joseph's Court 55+ in Levittown, PA, our one bedroom apartments offer a harmonious blend of style and functionality. These well-designed spaces provide the perfect setting for comfort and relaxation, tailored specifically for an enhanced living experience.\n\nLocated in the charming town of Levittown, our community boasts upscale amenities such as stainless steel appliances, hardwood floors, and a modern fitness center. With thoughtfully crafted interiors, enjoy all the conveniences you need right at home at The Residences. Discover your one bedroom retreat today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Levittown, PA One Bedroom Apartments",
      "seo_description": "Find one bedroom apartments in Levittown, PA with modern amenities at The Residences at St. Joseph's Court 55+.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-bucks-county-586",
      "search_query": "two bedroom apartments Bucks County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Bucks County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Bucks County. Enjoy modern living with ample space and premium amenities.",
      "page_copy": "The Residences at St. Joseph's Court 55+ in Levittown, located in beautiful Bucks County, offers two bedroom apartments that are designed to meet all your living needs. These spacious units provide an open and modern layout, perfect for relaxing or entertaining guests, while being set in a vibrant community atmosphere.\n\nOur community offers more than just a place to live; it offers a lifestyle. From stainless steel appliances and hardwood floors to a state-of-the-art fitness center, you’ll find everything you need at your fingertips. Experience the best of Bucks County living in our thoughtfully curated two bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bucks County Two Bedroom Apartments",
      "seo_description": "Explore two bedroom apartments in Bucks County with premium amenities at The Residences at St. Joseph's Court 55+.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "apartments-near-manor-elementary-school-levittown-835",
      "search_query": "apartments near Manor Elementary School Levittown",
      "category": "School",
      "h1_title": "Apartments Near Manor Elementary School",
      "h2_subtitle": "Find modern apartments near Manor Elementary School in Levittown. An ideal location with spacious living options awaits you.",
      "page_copy": "The Residences at St. Joseph's Court 55+ offers a prime location in Levittown, situated conveniently near Manor Elementary School. Our one and two-bedroom apartments are perfect for those seeking a blend of convenience and modern amenities.\n\nEmbrace a lifestyle of comfort with features like stainless steel appliances, hardwood floors, and a modern fitness center. Nestled in a vibrant neighborhood, the proximity to local schools such as Manor Elementary makes The Residences an excellent choice for those looking for community-focused living. Enjoy the benefits of Levittown living at its best!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Levittown Apartments Near Manor Elementary School",
      "seo_description": "Discover apartments near Manor Elementary School in Levittown with modern amenities at The Residences at St. Joseph's Court 55+.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "levittown-pa-apartments-by-penn-valley-elementary-school-749",
      "search_query": "Levittown PA apartments by Penn Valley Elementary School",
      "category": "School",
      "h1_title": "Levittown Apartments by Penn Valley School",
      "h2_subtitle": "Explore Levittown, PA apartments near Penn Valley Elementary School. Enjoy modern living with convenient access to local amenities.",
      "page_copy": "The Residences at St. Joseph's Court 55+ offers beautifully designed one and two-bedroom apartments in Levittown, PA, conveniently located near Penn Valley Elementary School. Experience living in a community that offers both proximity to educational facilities and luxurious modern comforts.\n\nOur amenities, including stainless steel appliances, hardwood floors, and a fitness center, enhance your living experience, making it not just a place to stay but a place to thrive. Choose our community for easy access to schools and an ideal living environment in vibrant Levittown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Penn Valley School in Levittown, PA",
      "seo_description": "Find Levittown, PA apartments near Penn Valley Elementary School at The Residences at St. Joseph's Court 55+ with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "levittown-senior-living-close-to-walt-disney-elementary-218",
      "search_query": "Levittown senior living close to Walt Disney Elementary School",
      "category": "School",
      "h1_title": "Levittown Senior Living Near Walt Disney School",
      "h2_subtitle": "Discover senior living options in Levittown near Walt Disney Elementary School. Experience a perfect blend of convenience and modern amenities.",
      "page_copy": "At The Residences at St. Joseph’s Court 55+ in Levittown, PA, we offer senior living solutions close to Walt Disney Elementary School. Our community is thoughtfully designed for those seeking a vibrant lifestyle with modern conveniences.\n\nEnjoy the benefits of living in a prime location with access to upscale amenities including a fitness center, stainless steel appliances, and inviting social spaces. Our community promises comfort and style, making it ideal for seniors looking to enjoy a leisurely lifestyle near essential amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Levittown Senior Living by Walt Disney School",
      "seo_description": "Experience premier senior living in Levittown near Walt Disney Elementary School at The Residences at St. Joseph's Court 55+.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "apartments-near-charles-boehm-middle-school-bucks-county-296",
      "search_query": "apartments near Charles Boehm Middle School Bucks County",
      "category": "School",
      "h1_title": "Apartments Near Charles Boehm Middle School",
      "h2_subtitle": "Discover Bucks County living with apartments near Charles Boehm Middle School. Enjoy modern amenities in our welcoming community.",
      "page_copy": "Situated in the heart of Bucks County, The Residences at St. Joseph's Court 55+ offers spacious one and two-bedroom apartment homes near Charles Boehm Middle School. Our community combines the tranquility of suburban living with easy access to educational institutions.\n\n residents enjoy top-tier amenities such as stainless steel appliances, hard wood floors, and a state-of-the-art fitness center. Choose us for a convenient and fulfilling lifestyle that keeps you close to all necessary conveniences in Bucks County and beyond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bucks County Apartments Near Charles Boehm School",
      "seo_description": "Find modern Bucks County apartments near Charles Boehm Middle School at The Residences at St. Joseph's Court 55+ with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "levittown-55-plus-residences-by-pennsbury-east-high-school-65",
      "search_query": "Levittown 55+ residences by Pennsbury East High School",
      "category": "School",
      "h1_title": "55+ Residences by Pennsbury East High",
      "h2_subtitle": "Explore 55+ residences in Levittown near Pennsbury East High School. Experience stylish living with convenient school access.",
      "page_copy": "Discover a vibrant lifestyle at The Residences at St. Joseph's Court 55+ in Levittown, PA, ideally located near Pennsbury East High School. Our community is designed for those aged 55 and over, offering beautifully appointed one and two-bedroom apartments.\n\nEmbrace modern living with our array of amenities, including a well-equipped fitness center, stainless steel appliances, and elegant hardwood floors. Our residences provide the perfect balance of comfort and convenience, ensuring you enjoy both senior living and proximity to educational establishments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "55+ Residences Near Pennsbury East High, Levittown",
      "seo_description": "Experience Levittown's 55+ residences near Pennsbury East High School, featuring premium amenities at The Residences at St. Joseph's Court.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "senior-apartments-near-center-for-student-learning-charter-137",
      "search_query": "senior apartments near Center for Student Learning Charter School",
      "category": "School",
      "h1_title": "Senior Apartments Near Student Learning Charter",
      "h2_subtitle": "Find senior apartments conveniently located near the Center for Student Learning Charter School in Levittown. Enjoy modern amenities with easy access.",
      "page_copy": "The Residences at St. Joseph's Court 55+ in Levittown, PA, offers an ideal setting for those seeking senior apartments near the Center for Student Learning Charter School. Our community is designed to provide both comfort and accessibility.\n\nResidents enjoy seamless living with upscale amenities such as a state-of-the-art fitness center, stainless steel appliances, and stylish hardwood floors. Experience senior living that keeps you connected to educational environments while providing a peaceful and elegant home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Senior Apartments Near Learning Charter School",
      "seo_description": "Explore senior apartments at The Residences at St. Joseph's Court 55+, conveniently near the Center for Student Learning Charter School in Levittown.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "thornridge-apartments-near-fallsington-elementary-school-136",
      "search_query": "Thornridge apartments near Fallsington Elementary School",
      "category": "School",
      "h1_title": "Thornridge Apartments Near Fallsington Elementary",
      "h2_subtitle": "Discover Thornridge apartments near Fallsington Elementary School in Levittown. Enjoy comfortable living with easy school access.",
      "page_copy": "Experience the best of Bucks County living at The Residences at St. Joseph's Court 55+, located in the Thornridge neighborhood and close to Fallsington Elementary School. Our community offers a selection of thoughtfully designed one and two-bedroom apartments.\n\nResidents can take advantage of amenities like a fully-equipped fitness center, stainless steel appliances, and elegant hardwood floors. Nestled in a serene setting, our apartments provide the perfect combination of comfort and convenience, ensuring a welcoming home atmosphere near local schools.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Thornridge Apartments by Fallsington Elementary",
      "seo_description": "Explore elegant Thornridge apartments near Fallsington Elementary School at The Residences at St. Joseph's Court. Ideal for convenient, modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "modern-apartments-by-village-park-academy-levittown-681",
      "search_query": "modern apartments by Village Park Academy Levittown",
      "category": "School",
      "h1_title": "Modern Apartments by Village Park Academy",
      "h2_subtitle": "Explore modern apartments in Levittown near Village Park Academy. Enjoy stylish features and a convenient location.",
      "page_copy": "The Residences at St. Joseph's Court 55+ is your gateway to stylish living in the heart of Levittown, PA. Situated conveniently near Village Park Academy, our modern apartments offer an ideal location for those seeking both comfort and proximity to educational institutions.\n\nOur thoughtfully designed one and two-bedroom floor plans are complemented by upscale amenities like stainless steel appliances, hardwood floors, and a fully-equipped fitness center. Experience the perfect blend of serenity and accessibility, making for an exceptional living experience in the Levittown area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments Near Village Park Academy",
      "seo_description": "Discover modern apartments at The Residences at St. Joseph's Court, conveniently located near Village Park Academy in Levittown. Enjoy stylish living today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "levittown-55-plus-living-near-bucks-community-college-718",
      "search_query": "Levittown 55+ living near Bucks County Community College Lower Bucks",
      "category": "School",
      "h1_title": "Levittown 55+ Living Near Bucks County College",
      "h2_subtitle": "Discover Levittown 55+ living close to Bucks County Community College Lower Bucks. Embrace comfort and convenience.",
      "page_copy": "Step into a vibrant lifestyle at The Residences at St. Joseph's Court 55+ in Levittown, PA. Perfectly situated near Bucks County Community College Lower Bucks, our community offers an ideal setting for active adults looking for convenience and modern comforts.\n\nResidents can enjoy features like hard-working stainless steel appliances, hardwood floors, and a contemporary fitness center. Within a short distance from educational opportunities, our spacious one and two-bedroom apartments provide a peaceful retreat with easy access to local attractions and learning institutions. Embrace your new chapter in an engaging environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Levittown 55+ Living Near College",
      "seo_description": "Explore Levittown 55+ living at The Residences at St. Joseph's Court, near Bucks County Community College Lower Bucks. Embrace comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "apartments-near-st-mary-medical-center-levittown-172",
      "search_query": "apartments near St. Mary Medical Center Levittown PA",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Mary Medical Center",
      "h2_subtitle": "Find comfortable apartments near St. Mary Medical Center in Levittown, PA. Enjoy modern living with convenient healthcare access.",
      "page_copy": "Discover exceptional living at The Residences at St. Joseph's Court 55+, strategically located near St. Mary Medical Center in Levittown, PA. Our community offers easy access to quality healthcare facilities while providing a serene residential atmosphere.\n\nOur spacious one and two-bedroom apartments feature upscale amenities such as stainless steel appliances and hardwood floors, complemented by a modern fitness center. Embrace the perfect balance of comfort and convenience, making it an ideal choice for those wanting proximity to medical services and a refined living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Mary Medical Center",
      "seo_description": "Explore The Residences at St. Joseph's Court, offering apartments near St. Mary Medical Center Levittown. Enjoy modern living with nearby healthcare access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "apartments-near-falls-township-community-park-levittown-914",
      "search_query": "apartments near Falls Township Community Park Levittown",
      "category": "Park",
      "h1_title": "Apartments Near Falls Township Community Park",
      "h2_subtitle": "Explore apartments near Falls Township Community Park in Levittown. Enjoy nature and modern living side by side.",
      "page_copy": "The Residences at St. Joseph's Court 55+ invites you to experience the perfect blend of nature and modern comfort in Levittown, PA. Located conveniently near Falls Township Community Park, our apartments offer easy access to beautiful outdoor spaces and recreational activities.\n\nResidents can revel in thoughtfully designed one and two-bedroom floor plans that feature upscale amenities like stainless steel appliances, hardwood floors, and a state-of-the-art fitness center. Embrace the tranquility and modern elegance of your new home, while enjoying convenient proximity to the lush green spaces of Falls Township Community Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Falls Township Community Park",
      "seo_description": "Discover tranquil living at The Residences near Falls Township Community Park. Enjoy nature's beauty and modern amenities in Levittown.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "apartments-by-core-creek-park-bucks-county-656",
      "search_query": "apartments by Core Creek Park Bucks County",
      "category": "Park",
      "h1_title": "Apartments by Core Creek Park",
      "h2_subtitle": "Find ideal apartments by Core Creek Park in Bucks County. Enjoy serene living with natural beauty on your doorstep.",
      "page_copy": "Discover the charm of The Residences at St. Joseph's Court 55+, located near the scenic Core Creek Park in Bucks County. Our apartments provide a serene retreat adjacent to natural beauty, allowing residents to enjoy an active outdoor lifestyle as well as modern conveniences.\n\nOur one and two-bedroom floor plans offer exceptional amenities, including hardwood floors and stainless steel appliances, complementing an elegant living experience. With a state-of-the-art fitness center and inviting social spaces, our location near Core Creek Park is perfect for those who value both comfort and natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Core Creek Park",
      "seo_description": "Live near Core Creek Park at The Residences in Bucks County. Enjoy serene apartment living with modern amenities and natural vistas.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "residences-close-to-neshaminy-state-park-pa-987",
      "search_query": "residences close to Neshaminy State Park PA",
      "category": "Park",
      "h1_title": "Residences Close to Neshaminy State Park",
      "h2_subtitle": "Discover residences close to Neshaminy State Park, PA. Enjoy park views and sophisticated living in Levittown.",
      "page_copy": "The Residences at St. Joseph's Court 55+ offers a prime location for nature enthusiasts, being close to Neshaminy State Park in PA. Enjoy the luxury of having scenic parklands just a short drive away, providing a plethora of outdoor activities while also savoring the upscale amenities in our community.\n\nChoose from spacious one and two-bedroom floor plans featuring modern elegance with amenities like stainless steel appliances and hardwood floors. Our state-of-the-art fitness center and beautifully designed social areas make this community a haven for those seeking both nature and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Close to Neshaminy State Park",
      "seo_description": "Discover The Residences at St. Joseph's Court, offering homes close to Neshaminy State Park PA. Enjoy park proximity and elegant living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "levittown-rentals-near-middletown-community-park-383",
      "search_query": "Levittown rentals near Middletown Community Park",
      "category": "Park",
      "h1_title": "Levittown Rentals Near Middletown Park",
      "h2_subtitle": "Explore Levittown rentals near Middletown Community Park. Experience vibrant living close to outdoor activities and modern conveniences.",
      "page_copy": "At The Residences at St. Joseph's Court 55+, enjoy rental living perfectly situated near Middletown Community Park in Levittown. Our location brings you close to the vibrant events and recreational facilities of the park, blending an active lifestyle with the peace of modern apartment living.\n\nOur community offers one and two-bedroom floor plans, each with upscale features like stainless steel appliances and gleaming hardwood floors. Engage with neighbors in our stylish social spaces or stay fit in our state-of-the-art fitness center, all while living just minutes away from the bustling Middletown Community Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Levittown Rentals Near Middletown Park",
      "seo_description": "Find rentals in Levittown near Middletown Community Park. Enjoy modern amenities and park activities at The Residences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "55-plus-living-near-middletown-veterans-memorial-park-650",
      "search_query": "55+ living near Middletown Veterans' Memorial Park Thornridge",
      "category": "Park",
      "h1_title": "55+ Living Near Middletown Veterans' Park",
      "h2_subtitle": "Experience 55+ living near Middletown Veterans' Memorial Park in Thornridge. Discover a vibrant community tailored for active adults.",
      "page_copy": "The Residences at St. Joseph's Court 55+ in Levittown offers senior living designed for comfort and convenience near Middletown Veterans' Memorial Park in Thornridge. Engage with a vibrant community, enjoy park visits, and take advantage of nearby amenities tailored for active adults.\n\nChoose from our meticulously crafted one and two-bedroom apartments, featuring modern touches like stainless steel appliances and hardwood floors. Our community is enhanced with a fitness center and welcoming social spaces, creating a perfect setting for enjoying life’s next chapter. Residents find both peace and a sense of belonging near this picturesque park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "55+ Living Near Middletown Veterans' Park",
      "seo_description": "Find vibrant 55+ living near Middletown Veterans' Memorial Park. Enjoy comfort and community at The Residences in Thornridge.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166355",
      "source": "custom",
      "page_item_url": "senior-apartments-by-tullytown-canal-park-19054-967",
      "search_query": "senior apartments by Tullytown Canal Park 19054",
      "category": "Park",
      "h1_title": "Senior Apartments by Tullytown Canal Park",
      "h2_subtitle": "Discover senior apartments conveniently located by Tullytown Canal Park in 19054. Experience comfortable and modern living tailored for you.",
      "page_copy": "The Residences at St. Joseph's Court 55+ offers a serene environment for seniors seeking apartments near Tullytown Canal Park in the 19054 area. This location provides unbeatable access to scenic park spaces, perfect for leisurely strolls and peaceful retreats close to nature.\n\nOur one and two-bedroom apartments feature upscale amenities including stainless steel appliances and elegant hardwood floors. Residents can maintain an active lifestyle with our fitness center and enjoy vibrant community events in our luxurious social spaces. Come home to a place where comfort meets convenience near Tullytown Canal Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot full of cars.",
        "public_id": "01a015dc-80b5-73bf-97c0-1fb9e143cf53",
        "storage_key": "property/6767906449166355/01a015dc-80b5-73bf-97c0-1fb9e143cf53.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Senior Apartments by Tullytown Canal Park",
      "seo_description": "Explore senior living by Tullytown Canal Park, 19054. Enjoy modern amenities and a vibrant community at The Residences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5092"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976289859"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973453"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KPMTH26Z"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://theresidencesatstjosephcourt.fatwin.com/api/websites/resources/1?x=WlRBSURycFJUUkIrcEtMWWxPZmlSNDJtOHdYdUtLWHdUS2lLNkw3Szl2U0hrc1FIc3ppQW5rbG5JeU0rRzdnTG9MVFJVZ2xVSi9ZYUU5d2U1bHVob0E9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/zlpo6zejpg4"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95486bfa-43e6-11ef-85ee-5b74d9a56f14"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95486bfa-43e6-11ef-85ee-5b74d9a56f14/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95486bfa-43e6-11ef-85ee-5b74d9a56f14/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InlpTllzVFJOajlNTXQ4NXcwMjZLaVE9PSIsInZhbHVlIjoiZmlzbnREdjlhMlpDOGJVcnpndU9hUT09IiwibWFjIjoiNWEwZDBkOTYyMjVhYTdlNTc1NzE5YjI5NjM4MGIzMDBkZjk3Y2ZlYzRmNDlmMDYxZDAzZDlkZTVhZTVkOTkzMSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5092",
  "custom_repli_id": "9976289859",
  "custom_realpage_id": "4973453",
  "custom_google_gtm_id": "GTM-KPMTH26Z",
  "custom_perq_script_url": "https://theresidencesatstjosephcourt.fatwin.com/api/websites/resources/1?x=WlRBSURycFJUUkIrcEtMWWxPZmlSNDJtOHdYdUtLWHdUS2lLNkw3Szl2U0hrc1FIc3ppQW5rbG5JeU0rRzdnTG9MVFJVZ2xVSi9ZYUU5d2U1bHVob0E9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/zlpo6zejpg4",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95486bfa-43e6-11ef-85ee-5b74d9a56f14",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95486bfa-43e6-11ef-85ee-5b74d9a56f14/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95486bfa-43e6-11ef-85ee-5b74d9a56f14/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InlpTllzVFJOajlNTXQ4NXcwMjZLaVE9PSIsInZhbHVlIjoiZmlzbnREdjlhMlpDOGJVcnpndU9hUT09IiwibWFjIjoiNWEwZDBkOTYyMjVhYTdlNTc1NzE5YjI5NjM4MGIzMDBkZjk3Y2ZlYzRmNDlmMDYxZDAzZDlkZTVhZTVkOTkzMSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "e17263cb-a885-4308-822d-56085bcec61e",
  "custom_audioeye_site_hash": "c0d2fa9c5b459d97f7dea46d88ba2186"
};

export const generatedAt = '2026-10-22T20:04:36.836Z';
